/* eslint-disable */
import {
	CheckCircle,
	ModeEdit,
	HighlightOff,
	Check,
	ArrowDownward,
	AddCircle,
} from '@mui/icons-material';
import { IconButton, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { ArrowRightToLine, Factory, Info, FileText } from 'lucide-react';
import moment from 'moment';
import { useEffect, useMemo, useState, useRef } from 'react';
import { useAuth } from '@/Components/Auth/Login/auth';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { analyticsAction, modalActions } from '../../../Actions';
import {
	classes,
	convertToLowerUnit,
	getHigherUnitAndQuantity,
	getUnitFamily,
	handleExcelDownload,
	multiplePoCustomers,
	useProductData,
} from '@/Helpers';
import { notificationServices } from '../../../Services';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import processFlowServices from '../../../Services/Analytics Services/process-flow.services';
// eslint-disable-next-line import/no-cycle
import { BaseModal } from '../BaseModal';
import styles from './ProductionPlanModal.module.scss';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { ListTable } from '@/Components/ListTable';
import { DatePicker, SelectPicker, Toggle } from 'rsuite';
import productionPlanServices from '../../../Services/Analytics Services/production-plan.services';
import weight from '@/Images/Weigh.svg';
import noWeight from '@/Images/noweigh.svg';
import { AlertModal } from '../AlertModal';
import useFeatureFlags from '@/Helpers/useFeatureFlags';
import { urls } from '@/Constants';
import { getProductionPlanColumns, buildVariantTableColumns } from './productionPlanColumns';
import VariantTable from '@/Pages/Food Products/VariantPrice/VariantTable';
import excel from '@/Images/excel.svg';
import uyLogo from '@/Images/logo.aeb5ee07.png';
import { jsPDF } from 'jspdf';

const ProductionPlanModal = (props) => {
	const history = useHistory();
	const { show, toggleProductionPlanModal, data, stores } = props;

	const [planDescription, setPlanDescription] = useState('');
	const [loading, setLoading] = useState(false);
	const [showPasteFormat, setShowPasteFormat] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [isEdit, setIsEdit] = useState({});
	const [isEditFinalProduction, setIsEditFinalProduction] = useState({});
	const [skipMeasurementToggles, setSkipMeasurementToggles] = useState({});
	const [listData, setListData] = useState({
		INGREDIENT: [],
		INTERMEDIATE: [],
		PRODUCT: [],
		PACKAGING: [],
		leftOverCheckPlannedAhead: false,
		stockCheckedAt: new Date(),
		storeInfo: {},
	});

	const isLeftOverCheck = !!listData?.leftOverCheckPlannedAhead;
	const [prevListData, setPrevListData] = useState({});
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
	const skuStock = useSelector(
		(state) => state?.analytics?.INVENTORY_ANALYTICS?.SKU_STOCK
	);
	const batches = useSelector((state) => state?.analytics?.INGREDIENT_LIST);
	const dispatch = useDispatch();
	const { appConfig = {} } = useAuth();
	const [shiftId, setShiftId] = useState(null);
	const [selectedDate, setSelectedDate] = useState(new Date());
	const [processList, setProcessList] = useState([]);
	const [reasonList, setReasonList] = useState([]);
	const shiftList = useSelector((state) => state?.analytics?.SHIFT_LIST);
	const filteredShiftList = useMemo(() => {
		if (!shiftList || !data?.storeId) return [];
		return shiftList.filter((shift) => shift?.storeId === data?.storeId);
	}, [shiftList, data?.storeId]);
	const isA2bCustomer = !multiplePoCustomers.includes(appConfig?.customerId);

	const { CAN_ORDER_IN_PACKS } = useFeatureFlags();
	const [poOrderQtyMap, setPoOrderQtyMap] = useState({});
	const [poOrderFetched, setPoOrderFetched] = useState(false);
	const [batchizeQtyMap, setBatchizeQtyMap] = useState({});

	const skuTypes = [
		{
			value: 'PRODUCT',
			color: '#FFE9ED',
			darkColor: '#db2777',
		},
		{
			value: 'INTERMEDIATE',
			color: '#FDF8E7',
			darkColor: '#d97706',
		},
		{
			value: 'INGREDIENT',
			color: '#E8FCE2',
			darkColor: '#16a34a',
		},
		{
			value: 'PACKAGING',
			color: '#EAF2FC',
			darkColor: '#2563eb',
		},
	].filter((item) => (item.value !== 'PACKAGING' || CAN_ORDER_IN_PACKS) && (item.value !== 'PACKAGING' || !data?.lppId));

	useEffect(() => {
		useProductData(dispatch);
	}, []);

	useEffect(() => {
		if (show && data?.lppId && data?.storeId) {
			dispatch(
				analyticsAction.gateway({
					entity: 'INVENTORY_ANALYTICS',
					req: { params: { type: 'stock', storeId: data?.storeId } },
					method: 'SKU_STOCK',
				})
			);
		}
	}, [data?.lppId]);

	const applyPoOrderQtyToData = (dataObj) => {
		if (!data?.lppId || !poOrderFetched || !dataObj) return dataObj;
		const next = { ...dataObj };
		['PRODUCT', 'INTERMEDIATE', 'UNPACKED_PRODUCT', 'INGREDIENT', 'PACKAGING'].forEach((key) => {
			if (Array.isArray(next[key])) {
				next[key] = next[key].map((item) => ({
					...item,
					orderedQty: poOrderQtyMap[item?.variantId] ?? null,
				}));
			}
		});
		return next;
	};

	// LPP: current stock (lppStockMap) ko data object pe set karta hai — pure function.
	const applyLppStockToData = (dataObj) => {
		if (!data?.lppId || !dataObj) return dataObj;
		const next = { ...dataObj };
		['PRODUCT', 'INTERMEDIATE', 'UNPACKED_PRODUCT', 'INGREDIENT', 'PACKAGING'].forEach((key) => {
			if (Array.isArray(next[key])) {
				next[key] = next[key].map((item) =>
					lppStockMap[item?.variantId] != null
						? { ...item, stock: lppStockMap[item.variantId] }
						: item
				);
			}
		});
		return next;
	};

	// LPP: batch size (batchizeQtyMap) ko data object pe set karta hai — pure function.
	const applyBatchSizeToData = (dataObj) => {
		if (!data?.lppId || !dataObj) return dataObj;
		const next = { ...dataObj };
		['PRODUCT', 'INTERMEDIATE', 'UNPACKED_PRODUCT', 'INGREDIENT', 'PACKAGING'].forEach((key) => {
			if (Array.isArray(next[key])) {
				next[key] = next[key].map((item) => ({
					...item,
					batchSize: batchizeQtyMap[item?.variantId],
				}));
			}
		});
		return next;
	};

	const lppStockMap = useMemo(() => {
		const map = {};
		if (Array.isArray(skuStock)) {
			skuStock.forEach((sku) => {
				(sku?.currentStock ?? []).forEach((cs) => {
					if (cs?.variantId != null) {
						map[cs.variantId] = Number(cs?.rawQty ?? 0);
					}
				});
			});
		}
		return map;
	}, [skuStock]);

	useEffect(() => {
		if (!data?.lppId) return;
		setListData((prev) => {
			const next = { ...prev };
			['PRODUCT', 'INTERMEDIATE', 'UNPACKED_PRODUCT', 'INGREDIENT', 'PACKAGING'].forEach(
				(key) => {
					if (Array.isArray(next[key])) {
						next[key] = next[key].map((item) =>
							lppStockMap[item?.variantId] != null
								? { ...item, stock: lppStockMap[item.variantId] }
								: item
						);
					}
				}
			);
			return next;
		});
	}, [lppStockMap, data?.lppId]);

	// LPP: PO order qty fetch karo (inventory/po/list) aur variantId -> total qty map banao.
	useEffect(() => {
		if (!data?.lppId || !data?.storeId) return;
		const fetchPoOrderQty = async () => {
			try {
				const planDate = moment(data?.date || new Date()).format('YYYY-MM-DD');
				const req = {
					data: {
						filters: {
							storeId: null,
							fromStoreId: data?.storeId,
							dateRangeFilter: {
								from: planDate,
								to: planDate,
								dateType: 'dispatchDate',
							},
							status: [],
							variantIds: [],
							orderType: 'sales/purchase',
							userOrderType: 'sales',
							productionPlanStatus: 'ALL',
						},
						showInternalData: false,
					},
				};
				const response = await inventoryAnalyticsServices.fetchPoList({ req });
				if (response?.statusCode === 200) {
					const orders = Array.isArray(response?.data)
						? response.data
						: (response?.data?.orders ?? []);
					const map = {};
					orders.forEach((order) => {
						if (order?.orderStatus !== 'PENDING') return;
						(order?.items ?? []).forEach((item) => {
							if (item?.variantId == null) return;
							const qty = Number(item?.qty) || 0;
							map[item.variantId] = (map[item.variantId] ?? 0) + qty;
						});
					});
					setPoOrderQtyMap(map);
					setPoOrderFetched(true);
				}
			} catch (error) {
				console.error('Error fetching PO order qty:', error);
			}
		};
		fetchPoOrderQty();
	}, [data?.lppId]);

	useEffect(() => {
		if (!data?.lppId || !data?.storeId) return;
		dispatch(analyticsAction.getIngredients(data?.storeId));
	}, [data?.lppId, data?.storeId]);

	useEffect(() => {
		if (!data?.lppId || !poOrderFetched) return;
		setListData((prev) => applyPoOrderQtyToData(prev));
	}, [poOrderQtyMap, poOrderFetched, data?.lppId]);

	useEffect(() => {
		if (!data?.lppId) return;
		const batchMap = {};
		batches?.forEach((batch) => {
			if (batch?.variantId != null) {
				batchMap[batch.variantId] = batch.batchSize;
			}
		});
		setBatchizeQtyMap(batchMap);
	}, [batches, data?.lppId]);

	// Apply batch size to list data when batchize map updates
	useEffect(() => {
		if (!data?.lppId) return;
		setListData((prev) => {
			const next = { ...prev };
			['PRODUCT', 'INTERMEDIATE', 'UNPACKED_PRODUCT', 'INGREDIENT', 'PACKAGING'].forEach((key) => {
				if (Array.isArray(next[key])) {
					next[key] = next[key].map((item) => ({
						...item,
						batchSize: batchizeQtyMap[item?.variantId],
					}));
				}
			});
			return next;
		});
	}, [batchizeQtyMap, data?.lppId]);


	useEffect(() => {
		const fetchProcesses = async () => {
			if (data?.storeId) {
				try {
					const response = await processFlowServices.fetchNodes({
						params: { storeId: data.storeId },
					});
					if (response?.statusCode === 200) {
						setProcessList(response?.data?.nodes ?? []);
					}
				} catch (error) {
					console.error('Error fetching processes:', error);
				}
			}
		};
		fetchProcesses();
	}, [data?.storeId]);

	useEffect(() => {
		const fetchReasons = async () => {
			try {
				const response = await inventoryAnalyticsServices.fetchCategoryList({
					req: {
						data: { type: 'PRODUCTION_PLAN_REASON' },
					}
				});
				if (response?.statusCode === 200) {
					setReasonList(response?.data?.categories ?? []);
				}
			} catch (error) {
				console.error('Error fetching reasons:', error);
			}
		};
		fetchReasons();
	}, []);
	const [selectedType, setSelectedType] = useState({
		value: 'PRODUCT',
		color: '#FFE9ED',
	});

	// Tab-based DISPLAY titles (table, excel export and PDF share these) — the
	// underlying column key stays 'Product Name' / 'Parent Product'.
	const displayColumnTitle = (title) => {
		if (title === 'Product Name') {
			const tabTitle = {
				PRODUCT: 'Finished Good',
				INTERMEDIATE: 'Semi Finished Good',
				INGREDIENT: 'Raw Materials',
			}[selectedType?.value];
			return tabTitle || title;
		}
		if (title === 'Parent Product') {
			return 'Parent Product (FG Product / SFG Product)';
		}
		return title;
	};
	const draftExists = data?.draftExists;
	const isDraftEdit = !!data?.draftKey;
	const draftKey = data?.draftKey;
	const onDraftSaved = data?.onDraftSaved;
	// --- END DRAFT HANDLING ---

	const stockCheckedAt = moment(data?.listData?.stockCheckedAt)?.format(
		'DD-MMM HH:mm'
	);
	const stockCheckAtDate = moment(data?.listData?.stockCheckedAt)?.format(
		'DD-MMM'
	);
	const checkedAtDate = new Date(data?.listData?.stockCheckedAt);
	checkedAtDate.setDate(checkedAtDate.getDate() + 1);
	const nextStockCheckAtDate = moment(checkedAtDate)?.format('DD-MMM');
	const scheduledFor = moment(selectedDate)?.format('DD-MMM');
	const plannedDate = moment(new Date()).format('DD-MM-YYYY');

	const COLMAP = {
		'Product Name': 'id',
		Reason: 'id',
		Unit: 'unit',
		Category: 'category',
		'Sub Category': 'subCategory',
		'UY Id': 'id',
		'SKU Code': 'clientVariantId',
		'Measure Quantity': 'id',
		'From Process': 'From Process',
		'To Process': 'To Process',
		'Select Yield Process': 'id',
		[`Stock At ${stockCheckedAt}`]: 'stock',
		[`Plan ${stockCheckAtDate} Produced till ${stockCheckedAt}`]:
			'currentDayStockIn',
		[`Plan ${stockCheckAtDate} Planned Production`]: 'currentDayCount',
		[`Projected Stock at ${nextStockCheckAtDate} 7:59 AM`]: 'prePlanStock',
		[`Minimum Stock at ${nextStockCheckAtDate} 7:59 AM`]: 'threshold',
		[`Order Quantity PO Delivery Date ${scheduledFor}`]: 'orderedQty',
		'Forecast for Next 7 Days': 'forecasted',
		Scheduled: 'scheduledAtDelta',
		'Production Factor (+/- Manual Calibration)': 'updatedQty',
		'Pre Batch Production Quantity': 'calculatedQty',
		'Batch Size': 'batchSize',
		'Final Production': 'finalProduction',
		'Final Indent': 'finalProduction',
		'Recipe Exists': 'skipped',
		'Recipe Status': 'recipeApprovalStatus',
		'Possible Production Qty': 'suggestedQty',
		[`Planned For Consumption ${plannedDate}`]: 'plannedForConsumption',
		[`Planned To be Received on ${plannedDate}`]: 'plannedToBeReceived',
		'No of batches': 'batchCount',
		'Shift ID': 'shiftId',
		'Shift Name': 'shiftName',
		'Parent Product': 'parentProduct',
		'Kit Batch Size': 'kitBatchSize',
		'Kit Count': 'kitCount',
		'Labelling Date': 'labellingDate',
		'Scheduled Date': 'scheduledDate',
	};

	const SPECIAL_COLUMNS = [
		{
			title: 'Product Name',
			fixed: true,
			width: 200,
		},
		{
			title: 'Unit',
			fixed: true,
			width: 60,
		},
		{
			title: 'Category',
			fixed: true,
			width: 100,
		},
		{
			title: 'Sub Category',
			fixed: true,
			width: 100,
		},
		{
			title: 'SKU Code',
			fixed: true,
			width: 100,
		},
		{
			title: 'Measure Quantity',
		},
		{
			title: 'From Process',
		},
		{
			title: 'To Process',
		},
		{
			title: 'Select Yield Process',
			width: 160,
		},
		{
			title: 'Scheduled',
		},
		{
			title: `Planned For Consumption ${plannedDate}`,
		},
		{
			title: `Planned To be Received on ${plannedDate}`,
		},
		{
			title: `Stock At ${stockCheckedAt}`,
		},
		{
			title: 'Left Over (Input)',
		},
		{
			title: `Plan ${stockCheckAtDate} Planned Extra Production`,
		},
		{
			title: `Plan ${stockCheckAtDate} Produced till ${stockCheckedAt}`,
		},
		{
			title: `Plan ${stockCheckAtDate} Planned Production`,
		},
		{
			title: `Projected Stock at ${nextStockCheckAtDate} 7:59 AM`,
		},
		{
			title: `Minimum Stock at ${nextStockCheckAtDate} 7:59 AM`,
		},
		{
			title: `Order Quantity PO Delivery Date ${scheduledFor}`,
		},
		{
			title: 'Recommended Production Qty',
			width: 160,
		},
		{
			title: 'Forecast for Next 7 Days',
		},
		{
			title: 'Production Factor (+/- Manual Calibration)',
			width: 160,
		},
		{
			title: 'Reason',
			width: 160,
		},
		{
			title: 'Expected Left Over',
		},
		// {
		// 	title: 'Stock Info',
		// 	config: {
		// 		type: 'DATA',
		// 	},
		// },
		{
			title: 'Required Stock',
		},
		{
			title: 'Current Stock',
		},
		{
			title: 'Status',
		},
		{
			title: 'Pre Batch Without Left Over',
		},

		{
			title: 'Left Over (Used/Input)',
		},
		{
			title: 'Left Over (Already Planned)',
		},
		{
			title: 'Left Over (From Executed plans)',
		},
		{
			title: 'Pre Batch Production Quantity',
		},
		{
			title: 'Possible Production Qty',
		},
		{
			title: 'Wastage %',
		},
		{
			title: 'Batch Size',
		},
		{
			title: 'Final Production',
		},
		{
			title: 'Final Indent',
		},
		{
			title: 'Recipe Exists',
		},
		{
			title: 'Recipe Status',
		},
		{
			title: 'No of batches',
		},
		{
			title: 'Shift ID',
		},
		{
			title: 'Shift Name',
		},
		{
			title: 'Parent Product',
			fixed: true,
		},
		{
			title: 'Kit Batch Size',
		},
		{
			title: 'Kit Count',
		},
		{
			title: 'Labelling Date',
		},
		{
			title: 'Scheduled Date',
		},
	];

	// Packaging-specific columns
	const PACKAGING_COLUMNS = [
		{
			title: 'Item Name',
		},
		{
			title: 'Item Code',
		},
		{
			title: 'Pack Size',
		},
		{
			title: 'Production Factor (+/- Manual Calibration)',
		},
		{
			title: 'Packs Ordered',
		},
		{
			title: 'Available Packs in Stock',
		},
		{
			title: 'Packs to be packed',
		},
		{
			title: 'Qty of SKU required',
		},
	];

	const mergeDelta = (saved, fresh) => {
		const merged = { ...fresh };

		Object.keys(fresh).forEach((key) => {
			if (Array.isArray(fresh[key])) {
				merged[key] = fresh[key].map((item) => {
					const id = getElementId(item);
					const matchingSaved = saved[key]?.find(
						(savedItem) => getElementId(savedItem) === id
					);
					return {
						...item,
						delta: matchingSaved?.delta ?? item.delta,
						updatedPacksToBePacked:
							matchingSaved?.updatedPacksToBePacked ??
							item.updatedPacksToBePacked,
					};
				});
			}
		});

		return merged;
	};


	const initializeLocalFields = (dataObj) => {
		const result = { ...dataObj };
		['PRODUCT', 'INTERMEDIATE', 'UNPACKED_PRODUCT', 'PACKAGING', 'INGREDIENT'].forEach((key) => {
			if (Array.isArray(result[key])) {
				result[key] = result[key].map((item) => ({
					...item,
					initialProductionQty: item.finalProduction,
					initialDelta: item?.delta ?? 0,
					tempProductionValue: getHigherUnitAndQuantity(item?.unit, item?.finalProduction)[0],
					prevTempProductionValue: getHigherUnitAndQuantity(item?.unit, item?.finalProduction)[0],
				}));
			}
		});
		return result;
	};

	useEffect(() => {
		const saved = localStorage.getItem('unsavedListData');

		if (saved && data?.listData) {
			try {
				const savedData = JSON.parse(saved);
				const merged = mergeDelta(savedData, data.listData);
				setListData(initializeLocalFields(merged));
			} catch (e) {
				console.error('Invalid saved listData:', e);
				setListData(initializeLocalFields(data.listData));
			}
		} else if (data?.listData) {
			setListData(initializeLocalFields(data.listData));
		}

		// Initialize skipMeasurementToggles from data
		if (
			data?.listData?.skipMeasurementProducts &&
			Array.isArray(data.listData.skipMeasurementProducts)
		) {
			const initialToggles = {};
			data.listData.skipMeasurementProducts.forEach((productId) => {
				initialToggles[productId] = true;
			});
			setSkipMeasurementToggles(initialToggles);
		}
	}, [data?.listData]);

	useEffect(() => {
		setSelectedDate(new Date(data?.date));
		if (data?.shiftId) {
			setShiftId(data?.shiftId);
		}
	}, [data])

	useEffect(() => {
		if (shiftList?.length === 0) {
			dispatch(analyticsAction?.getShifts());
		}
	}, []);

	const autoSaveKey =
		draftKey ||
		(data?.idsList ? `unsavedListData_${data?.idsList.join('_')}` : null);
	const prevListDataRef = useRef();
	useEffect(() => {
		try {
			if (autoSaveKey && listData && listData !== prevListDataRef.current) {
				const draftObj = {
					...listData,
					idsList: data?.idsList ?? [],
					planDescription,
					skipMeasurementToggles,
				};
				localStorage.setItem(autoSaveKey, JSON.stringify(draftObj));
				prevListDataRef.current = listData;
			}
		} catch (e) {
			console.error('Error saving draft:', e);
		}
	}, [
		listData,
		autoSaveKey,
		data?.idsList,
		planDescription,
		skipMeasurementToggles,
	]);

	useEffect(() => {
		if (show && draftKey && localStorage.getItem(draftKey)) {
			try {
				const draft = JSON.parse(localStorage.getItem(draftKey));
				if (draft.planDescription !== undefined)
					setPlanDescription(draft.planDescription);
				if (draft.skipMeasurementToggles !== undefined)
					setSkipMeasurementToggles(draft.skipMeasurementToggles);
				if (
					draft.idsList !== undefined &&
					Array.isArray(draft.idsList)
				) {
					// Optionally set idsList in parent if needed
				}
			} catch (e) { }
		} else if (show && data?.planDescription) {
			setPlanDescription(data.planDescription);
		} else if (show && data?.lppId) {
			// Long-term-plan flow: auto-suggest the plan name using the same
			// `Plan DD MMM` logic as the Initiate Production Plan modal.
			setPlanDescription(`Plan ${moment(data?.date || new Date()).format('DD MMM')}`);
		}

		// Initialize skipMeasurementToggles from data if no draft exists
		if (
			show &&
			!draftKey &&
			data?.listData?.skipMeasurementProducts &&
			Array.isArray(data.listData.skipMeasurementProducts)
		) {
			const initialToggles = {};
			data.listData.skipMeasurementProducts.forEach((productId) => {
				initialToggles[productId] = true;
			});
			setSkipMeasurementToggles(initialToggles);
		}
	}, [show, draftKey, data?.planDescription, data?.lppId, data?.date, data?.listData?.skipMeasurementProducts]);



	const handleClose = (productionPlanId = null, generated = false) => {
		setPlanDescription('');
		setPrevListData({});
		setIsEdit({});
		setSkipMeasurementToggles({});
		setIsEditFinalProduction({});
		toggleProductionPlanModal(false, {});
		const passedId =
			typeof productionPlanId === 'string' || typeof productionPlanId === 'number'
				? productionPlanId
				: undefined;
		const ppId = passedId ?? data?.productionPlanId;
		const id = (typeof ppId === 'string' || typeof ppId === 'number') ? ppId : undefined;
		if (props.onCloseModal) { props.onCloseModal(id, generated) } else {
			history.push(
				`${urls.EXTENSION}${urls.PRODUCTION_PLANS}?id=${response?.data?.productionPlanId}`
			);
		};
	};

	const getUpdatedQty = (delta, orderedQty, updatedQty) => {
		if (!delta) {
			return updatedQty;
		}
		return Number(delta) + (orderedQty ?? 0);
		// return updatedQty;
	};

	const getElementId = (ele) => {
		return (
			String(ele?.variantId ?? '') +
			'_' + String(ele?.fromProcessId ?? '') +
			'_' + String(ele?.scheduledAtDelta ?? '') +
			(ele?.packId ? '_pk' + ele.packId : '') +
			(ele?.shiftId != null ? '_s' + ele.shiftId : '') +
			(ele?.parentProduct ? '_p' + ele.parentProduct : '')
		);
	};

	const items = useMemo(() => {
		const flattenData = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
			...(listData?.UNPACKED_PRODUCT ?? []),
			...(listData?.PACKAGING ?? []),
		];
		if (show) {
			const temp = flattenData?.map((ele) => {
				const { delta, ...restEle } = ele ?? {};
				return {
					...restEle,
					updatedQty: getUpdatedQty(
						delta,
						ele?.orderedQty,
						ele?.updatedQty
					),
					updatedPacksToBePacked:
						ele?.updatedPacksToBePacked != null &&
							ele?.updatedPacksToBePacked !== '' &&
							!isNaN(parseFloat(ele?.updatedPacksToBePacked))
							? parseFloat(ele?.updatedPacksToBePacked)
							: null,
				};
			});
			return temp;
		}
		return [];
	}, [data?.listData, listData?.PRODUCT, listData?.INTERMEDIATE, listData?.UNPACKED_PRODUCT, listData?.PACKAGING]);

	const getUniqueSkipMeasurementIds = () => {
		try {
			if (!listData?.INGREDIENT || !Array.isArray(listData?.INGREDIENT)) {
				return [];
			}

			const allProductIds = [];


			Object.keys(skipMeasurementToggles).forEach(productId => {
				if (skipMeasurementToggles[productId]) {
					allProductIds.push(parseInt(productId));
				}
			});

			return [...new Set(allProductIds)];

		} catch (error) {
			console.error('Error processing skip measurement data:', error);
			return [];
		}
	};

	const handleConfirm = async () => {
		dispatch(modalActions?.toggleAlert(false));
		let submitIdsList = data?.idsList ?? [];
		let submitPlanDescription = planDescription;
		if (draftKey && localStorage.getItem(draftKey)) {
			try {
				const draft = JSON.parse(localStorage.getItem(draftKey));
				if (draft.idsList !== undefined) submitIdsList = draft.idsList;
				// if (draft.planDescription !== undefined) submitPlanDescription = draft.planDescription;
			} catch (e) { }
		}
		if (
			submitIdsList &&
			submitIdsList.length === 0 &&
			!draftExists &&
			!data?.editMode &&
			!data?.lppId
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'No PO Selected',
			});
			return;
		}
		if (!draftExists && !data?.storeId) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'No Store selected',
			});
			return;
		}
		if (!submitPlanDescription) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please add Plan Description',
			});
			return;
		}
		if (isAllFinalProductionZero()) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Final Production is 0 for all products. Nothing to produce.',
			});
			return;
		}
		// Validate reason selection for changed items
		const allChangedItems = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
		].filter((ele) => ele?.delta != null && ele?.delta !== 0);
		const missingReason = allChangedItems.some((ele) => {
			if (!ele?.reasonId) return true;
			const reason = reasonList.find((r) => String(r.id) === String(ele?.reasonId));
			if (reason?.value === 'Other' && !ele?.customReasonInput) return true;
			return false;
		});
		if (missingReason && Array.isArray(reasonList) && reasonList?.length > 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a reason for all items where Production Factor has been changed',
			});
			return;
		}
		const req = {
			data: {
				...(data?.productionPlanId
					? { cancelPPId: data?.productionPlanId }
					: {}),
				poIds: submitIdsList,
				description: submitPlanDescription,
				storeId: data?.storeId,
				items,
				stockCheckedAt: data?.listData?.stockCheckedAt,
				storeInfo: data?.listData?.storeInfo,
				shiftId: shiftId ? Number(shiftId) : null,
				skipMeasurementProducts: getUniqueSkipMeasurementIds(),
				...(data?.lppId ? { lppId: data?.lppId } : {}),
				...(data?.shiftDistribution ? { shiftDistribution: data?.shiftDistribution } : {}),
				...(data?.planId ? { planId: data?.planId } : {})
			},
		};
		if (selectedDate) {
			req.data.date = moment(selectedDate).format('YYYY-MM-DD');
		}
		try {
			setLoading(true);
			const response =
				await inventoryAnalyticsServices?.generateProductionPlan(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Generated Successfully',
				});
				handleClose(response?.data?.productionPlanId, true);
				localStorage.removeItem('unsavedListData');
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error Occurred',
			});
		} finally {
			setLoading(false);
		}
	};

	const handleRecalculate = async () => {
		const allChangedItems = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
		].filter((ele) => ele?.delta != null && ele?.delta !== 0);

		const missingReason = allChangedItems.some((ele) => {
			if (!ele?.reasonId) return true;
			const reason = reasonList.find((r) => String(r.id) === String(ele?.reasonId));
			if (reason?.value === 'Other' && !ele?.customReasonInput) return true;
			return false;
		});

		if (missingReason && Array.isArray(reasonList) && reasonList?.length > 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a reason for all items where Production Factor has been changed',
			});
			return;
		}

		let recalcIdsList = data?.idsList ?? [];
		let recalcPlanDescription = planDescription;
		if (draftKey && localStorage.getItem(draftKey)) {
			try {
				const draft = JSON.parse(localStorage.getItem(draftKey));
				if (draft.idsList !== undefined) recalcIdsList = draft.idsList;
				if (draft.planDescription !== undefined) recalcPlanDescription = draft.planDescription;
			} catch (e) { }
		}
		setLoading(true);
		try {
			setPrevListData(listData);
			const req = {
				data: {
					poIds: recalcIdsList,
					storeId: data?.storeId,
					date: moment(selectedDate).format('YYYY-MM-DD'),
					recalculate: true,
					stockCheckedAt: data?.listData?.stockCheckedAt,
					storeInfo: data?.listData?.storeInfo,
					items,
					shiftId: shiftId ? Number(shiftId) : null,
					description: recalcPlanDescription,
					...(data?.shiftDistribution ? { shiftDistribution: data?.shiftDistribution } : {}),
					...(data?.lppId ? { lppId: data?.lppId } : {}),
					...(data?.planId ? { planId: data?.planId } : {})
				},
			};
			const response =
				await inventoryAnalyticsServices?.fetchProductionPlan(req);
			if (response?.statusCode === 200) {
				// LPP: after recalc, keep PO order qty, apply current stock and batch size
				const enriched = applyBatchSizeToData(
					applyLppStockToData(
						applyPoOrderQtyToData(initializeLocalFields(response?.data))
					)
				);
				setListData(enriched);
				setIsEdit({});
				setIsEditFinalProduction({});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Generated Successfully',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error Occurred',
			});
		} finally {
			setLoading(false);
		}
	};

	const checkLowStock = () => {
		const productLowStock = listData?.PRODUCT?.filter((ele) => {
			return ele?.lowStock;
		}).some((ele) => {
			return ele?.lowStock;
		});
		const intermediateLowStock = [...listData?.INTERMEDIATE, ...(listData?.UNPACKED_PRODUCT ?? [])]?.filter((ele) => {
			return ele?.lowStock;
		}).some((ele) => {
			return ele?.lowStock;
		});
		const ingredientLowStock = listData?.INGREDIENT?.filter((ele) => {
			return ele?.lowStock && ele?.threshold !== 0;
		}).some((ele) => {
			return ele?.lowStock;
		});
		if (productLowStock || intermediateLowStock || ingredientLowStock) {
			return true;
		}
		return false;
	};

	const handleConfirmation = () => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: data?.editMode
				? 'Edit Production Plan'
				: 'Generate Production Plan',
			message: data?.editMode
				? 'Are you sure you want to edit this production plan?'
				: 'Are you sure you want to generate this production plan?',
			handleConfirm: handleConfirm
		}))
	}

	// LPP: Final Production har scheduled item ke liye mandatory hai —
	// koi value empty ya 0 hai to Generate disable.
	const lppFinalProductionMissing = () => {
		if (!data?.lppId) return false;
		const items = [
			...(listData?.PRODUCT ?? []),
		];
		return items.some((ele) => {
			if (ele?.notScheduled) return false;
			const fp = ele?.finalProduction;
			// 0 is a valid value (= don't produce this product). Only a genuinely
			// empty field is "missing". All-zero case handled by isAllFinalProductionZero().
			return fp == null || fp === '';
		});
	};
	const getLppBatchInvalidProductNames = () => {
		if (!data?.lppId) return [];
		return (listData?.PRODUCT ?? [])
			.filter((ele) => {
				if (ele?.notScheduled) return false;
				const batch = Number(ele?.batchSize) || 0;
				if (batch <= 0) return false;
				const temp = ele?.tempProductionValue;
				if (temp === '' || temp == null || !Number.isFinite(temp) || temp === 0) return false; // empty -> empty check dekhega
				const [batchHigher] = getHigherUnitAndQuantity(ele?.unit, batch);
				return Math.abs(temp / batchHigher - Math.round(temp / batchHigher)) > 1e-6;
			})
			.map((ele) => ele?.productName + (ele?.variantName ? ` (${ele.variantName})` : ''));
	};

	// Final Production input sirf in modes me editable hai: LPP, ya customer 70/73 (PRODUCT).
	// Yahan sirf wahi products laao jinki value USER ne change ki (touched) aur ab empty/0
	// chhod di — i.e. "change karke khaali kar diya". Jo rows shuru se hi empty thi (untouched)
	// unhe yahan flag nahi karte. notScheduled rows skip.
	const getEmptyFinalProductionNames = () => {
		const editableForCustomer = ['70', '73'].includes(String(appConfig?.customerId));
		if (data?.nonEditable || data?.finalProductionNonEditable
			|| (!data?.lppId && !editableForCustomer)) return [];
		const scheduled = (listData?.PRODUCT ?? []).filter((ele) => !ele?.notScheduled);
		// Jab SAARI scheduled products ki Final Production 0/empty ho — sab ke naam dikhao
		// (chahe user ne touch kiya ho ya nahi).
		if (isAllFinalProductionZero()) {
			return scheduled.map(
				(ele) => ele?.productName + (ele?.variantName ? ` (${ele.variantName})` : '')
			);
		}
		return scheduled
			.filter((ele) => {
				const touched = Object.prototype.hasOwnProperty.call(
					isEditFinalProduction || {},
					getElementId(ele)
				);
				if (!touched) return false; // sirf jab user ne value change ki ho
				const temp = ele?.tempProductionValue;
				const fp = ele?.finalProduction;
				// 0 is a valid value (= don't produce this product), so it is NOT "empty".
				// Only a genuinely blank field counts. All-zero case handled above.
				const tempEmpty = temp === '' || temp == null;
				const fpEmpty = fp === '' || fp == null;
				return tempEmpty || fpEmpty;
			})
			.map((ele) => ele?.productName + (ele?.variantName ? ` (${ele.variantName})` : ''));
	};

	// LPP / customer 70/73: agar SAARI scheduled products ki Final Production 0 (ya empty)
	// hai to plan me kuch produce nahi hoga — Generate block karo.
	const isAllFinalProductionZero = () => {
		const editableForCustomer = ['70', '73'].includes(String(appConfig?.customerId));
		if (data?.nonEditable || data?.finalProductionNonEditable
			|| (!data?.lppId && !editableForCustomer)) return false;
		const scheduled = (listData?.PRODUCT ?? []).filter((ele) => !ele?.notScheduled);
		if (scheduled.length === 0) return false;
		return scheduled.every((ele) => {
			const fp = ele?.finalProduction;
			return fp == null || fp === '' || Number(fp) === 0;
		});
	};

	const getPendingRecipeProductNames = () => {
		const statusMap = listData?.recipeApprovalStatus;
		if (!statusMap) return [];

		const allProducts = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
			...(listData?.UNPACKED_PRODUCT ?? []),
		];

		const pendingProducts = [];
		const seen = new Set();

		allProducts.forEach((ele) => {
			const status = statusMap?.[ele?.productId];
			if (status && String(status).toUpperCase() === 'APPROVAL_PENDING') {
				const name = ele?.productName + (ele?.variantName ? ` (${ele.variantName})` : '');
				if (!seen.has(name)) {
					seen.add(name);
					pendingProducts.push(name);
				}
			}
		});
		return pendingProducts;
	};

	const getEditedProductNames = () => {
		const ids = [
			...Object.keys(isEdit || {}).filter((k) => isEdit[k]),
			...Object.keys(isEditFinalProduction || {}).filter((k) => isEditFinalProduction[k]),
		];
		if (ids.length === 0) return [];
		const all = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
			...(listData?.UNPACKED_PRODUCT ?? []),
			...(listData?.PACKAGING ?? []),
		];
		const seen = new Set();
		const names = [];
		ids.forEach((id) => {
			if (seen.has(id)) return;
			seen.add(id);
			const ele = all.find((e) => getElementId(e) === id);
			if (ele) names.push(ele?.productName + (ele?.variantName ? ` (${ele.variantName})` : ''));
		});
		return names;
	};

	const renderBtns = () => {
		const batchInvalidNames = getLppBatchInvalidProductNames();
		const emptyFinalProductionNames = getEmptyFinalProductionNames();
		return (
			!data?.hideButtons && (
				<div className={styles.btns}>
					<Button
						className='flex-1'
						disabled={(Object.keys(isEdit)?.length === 0 && Object.keys(isEditFinalProduction)?.length === 0) || loading || emptyFinalProductionNames.length > 0 || batchInvalidNames.length > 0}
						onClick={handleRecalculate}
						variant='secondary'
					>
						Re-Calculate
					</Button>
					<Button
						className='flex-1 primary-btn'
						onClick={handleConfirmation}
						disabled={checkLowStock() || loading || ((Object.keys(isEdit)?.length > 0 || Object.keys(isEditFinalProduction)?.length > 0)) || lppFinalProductionMissing() || emptyFinalProductionNames.length > 0 || batchInvalidNames.length > 0 || isAllFinalProductionZero()}
					>
						{loading ? 'Loading...' : 'Generate'}
					</Button>
				</div>
			)
		);
	};

	const handleChange = (e) => {
		setPlanDescription(e.target.value);
	};

	const handleEditClick = (varId) => {
		setIsEdit((prev) => {
			const temp = {
				...prev,
			};
			if (temp[varId]) {
				temp[varId] = false;
			} else {
				temp[varId] = true;
			}
			return temp;
		});
	};

	const handleFinalProductionEditClick = (varId) => {
		setIsEditFinalProduction((prev) => {
			const temp = {
				...prev,
			};
			if (temp[varId]) {
				temp[varId] = false;
			} else {
				temp[varId] = true;
			}
			return temp;
		});
	};

	const handleFinalProductionChange = (e, elementId) => {
		const inputValue = e?.target.value;
		// Prevent negative numbers
		if (inputValue !== '' && Number(inputValue) < 0) return;

		// Update the temporary value in list data
		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;

			temp[currentType] = temp[currentType]?.map((ele) => {
				if (elementId === getElementId(ele)) {
					return {
						...ele,
						tempProductionValue: inputValue,
					};
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const getRecommendedQty = (ele) => {
		const rec = Math.max(0, (ele?.orderedQty ?? 0) - (ele?.stock ?? 0));
		const batch = Number(ele?.batchSize) || 0;
		const planned = Number(ele?.calculatedQty) || 0;
		if (batch <= 0 || rec <= 0) return rec;
		if (Math.abs(rec % batch) < 1e-6) return rec;
		if (rec < planned) return planned;
		return Math.ceil(rec / batch) * batch;
	};

	// Planned (calculatedQty) ko full batches me round-up karke deta hai.
	const getPlannedBatchQty = (ele) => {
		let planned = Number(ele?.calculatedQty) || 0;
		const batch = Number(ele?.batchSize) || 0;
		if (batch > 0 && planned > 0) planned = Math.ceil(planned / batch) * batch;
		return planned;
	};

	// Recommended/Planned qty ko Final Production me set karta hai (shared logic).
	// getQty: (ele) => number — kaunsi qty set karni hai woh decide karta hai.
	const applyQtyToFinal = (id, getQty) => {
		const currentType = selectedType?.value;
		setListData((prev) => {
			const temp = { ...prev };
			temp[currentType] = temp[currentType]?.map((ele) => {
				if (getElementId(ele) !== id) return ele;
				const qty = Number(getQty(ele)) || 0;
				const [higher] = getHigherUnitAndQuantity(ele?.unit, qty);
				return {
					...ele,
					finalProduction: qty,
					tempProductionValue: String(higher),
					prevTempProductionValue: String(higher),
				};
			});
			return { ...temp };
		});
		setIsEditFinalProduction((prev) => {
			const next = { ...prev };
			delete next[id];
			return next;
		});
	};

	const applyRecommendedToFinal = (id) => applyQtyToFinal(id, getRecommendedQty);
	const applyPlannedToFinal = (id) => applyQtyToFinal(id, getPlannedBatchQty);

	const handleFinalProductionSave = (elementId) => {
		// LPP: Final Production batch size ka multiple honi chahiye. Multiple nahi hai to
		// warning de ke save block kar do (edit mode me hi rehne do); valid hone par neeche
		// normal delta + recalculate flow chalta hai.
		if (data?.lppId) {
			const ele = listData?.[selectedType?.value]?.find((p) => getElementId(p) === elementId);
			const inputValue = ele?.tempProductionValue;
			const lowerUnitValue =
				inputValue !== '' && inputValue !== null && inputValue !== undefined
					? convertToLowerUnit(ele?.unit, inputValue)
					: inputValue;
			const batch = Number(ele?.batchSize) || 0;
			if (
				batch > 0 &&
				lowerUnitValue !== '' &&
				lowerUnitValue != null &&
				Math.abs(Number(lowerUnitValue) % batch) > 1e-6
			) {
				const [batchHigher] = getHigherUnitAndQuantity(ele?.unit, batch);
				notificationServices.generateNotification({
					type: 'warning',
					message: `Final Production must be a multiple of the batch size (${batchHigher}).`,
				});
				return; // keep editing; don't save
			}
		}
		// LPP mode: koi delta/recalculate nahi — bas entered value set ho jaye.
		// if (data?.lppId) {
		// 	const currentType = selectedType?.value;
		// 	const ele = listData?.[currentType]?.find(
		// 		(p) => getElementId(p) === elementId
		// 	);
		// 	const inputValue = ele?.tempProductionValue;
		// 	const lowerUnitValue =
		// 		inputValue !== '' && inputValue !== null && inputValue !== undefined
		// 			? convertToLowerUnit(ele?.unit, inputValue)
		// 			: inputValue;

		// 	// Final Production batch size ka multiple honi chahiye.
		// 	const batch = Number(ele?.batchSize) || 0;
		// 	if (
		// 		batch > 0 &&
		// 		lowerUnitValue !== '' &&
		// 		lowerUnitValue != null &&
		// 		Math.abs(Number(lowerUnitValue) % batch) > 1e-6
		// 	) {
		// 		const [batchHigher] = getHigherUnitAndQuantity(ele?.unit, batch);
		// 		notificationServices.generateNotification({
		// 			type: 'warning',
		// 			message: `Final Production must be a multiple of the batch size (${batchHigher}).`,
		// 		});
		// 		return; // keep editing; don't save
		// 	}

		// 	setListData((prev) => {
		// 		const temp = { ...prev };
		// 		temp[currentType] = temp[currentType]?.map((p) => {
		// 			if (getElementId(p) === elementId) {
		// 				return {
		// 					...p,
		// 					finalProduction: lowerUnitValue,
		// 					prevTempProductionValue: inputValue,
		// 				};
		// 			}
		// 			return p;
		// 		});
		// 		return { ...temp };
		// 	});
		// 	// Edit flag clear -> Generate block na ho aur recalc ki zaroorat na pade.
		// 	setIsEditFinalProduction((prev) => {
		// 		const next = { ...prev };
		// 		delete next[elementId];
		// 		return next;
		// 	});
		// 	return;
		// }

		// No-change guard: agar user ne sirf input me click/focus kiya aur bina value
		// badle blur kar diya, to koi delta recompute / pending-edit flag nahi banna
		// chahiye (warna "production manual factor has changed" message galat aata hai).
		const savingEle = listData?.[selectedType?.value]?.find(
			(p) => getElementId(p) === elementId
		);
		const valueUnchanged =
			savingEle &&
			String(savingEle?.tempProductionValue ?? '') ===
			String(savingEle?.prevTempProductionValue ?? '');
		if (valueUnchanged) {
			// Net change tab hi hai jab item ka delta non-zero ho ya finalProduction
			// apni original value (initialProductionQty) se alag ho. Aisa ho to edit-mode
			// band karke pending-recalc flag rakho; warna key hi hata do.
			const hasNetChange =
				(savingEle?.delta != null && Number(savingEle?.delta) !== 0) ||
				(Number.isFinite(Number(savingEle?.initialProductionQty)) &&
					Number(savingEle?.finalProduction) !==
					Number(savingEle?.initialProductionQty));
			setIsEditFinalProduction((prev) => {
				const next = { ...prev };
				if (hasNetChange) {
					next[elementId] = false;
				} else {
					delete next[elementId];
				}
				return next;
			});
			return;
		}

		// Returned-to-original guard: agar user value badal ke wapas original
		// (initialProductionQty) par le aaya, to net koi change nahi — delta ko baseline
		// par restore karo aur edit flag hata do (recalc message na aaye).
		const savedInput = savingEle?.tempProductionValue;
		const savedLower =
			savedInput !== '' && savedInput !== null && savedInput !== undefined
				? convertToLowerUnit(savingEle?.unit, savedInput)
				: savedInput;
		const returnedToOriginal =
			savingEle &&
			Number.isFinite(Number(savingEle?.initialProductionQty)) &&
			savedLower !== '' &&
			savedLower != null &&
			Number(savedLower) === Number(savingEle?.initialProductionQty);

		let validationFailed = false;

		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;

			temp[currentType] = temp[currentType]?.map((ele) => {
				if (elementId === getElementId(ele)) {
					const inputValue = ele.tempProductionValue;
					const lowerUnitValue = inputValue !== '' && inputValue !== null
						? convertToLowerUnit(ele?.unit, inputValue)
						: inputValue;
					if (returnedToOriginal) {
						return {
							...ele,
							finalProduction: ele?.initialProductionQty,
							delta: ele?.initialDelta ?? 0,
							prevTempProductionValue: inputValue,
						};
					}
					const deltaValue = ele?.updatedQty === ele?.orderedQty
						? 0
						: ele?.updatedQty - ele?.orderedQty;
					const nonAdjustQty = ele?.calculatedQtyNonAdjusted < 0 ? Math.abs(parseFloat(ele?.calculatedQtyNonAdjusted)) : 0;
					const oldDeltaValue = ele?.delta ? ele?.delta : deltaValue
					const initialLowerQty = ele.prevTempProductionValue ? convertToLowerUnit(ele?.unit, ele.prevTempProductionValue) : 0;
					const newDelta = (oldDeltaValue + (lowerUnitValue - initialLowerQty)) + nonAdjustQty;
					const initialProductItem = prevListData?.[currentType]?.find((prod) => getElementId(prod) === elementId);
					let minPossibleVal;
					if (initialProductItem && initialProductItem?.delta) {
						minPossibleVal = Number(ele?.calculatedQty - Number(initialProductItem?.delta));
					} else {
						minPossibleVal = ele?.calculatedQty;
					}

					if (newDelta < -minPossibleVal) {
						validationFailed = true;

						const minAllowedLower = minPossibleVal;
						const [minAllowedHigher] = getHigherUnitAndQuantity(ele?.unit, minAllowedLower);

						notificationServices.generateNotification({
							type: 'warning',
							message: `Value too low. The minimum allowed production quantity is -${Number(minAllowedHigher).toFixed(2)}.`,
						});
						return ele;
					}
					return {
						...ele,
						finalProduction: lowerUnitValue,
						delta: newDelta,
						prevTempProductionValue: inputValue,
					};
				}
				return ele;
			});
			return { ...temp };
		});

		if (validationFailed) {
			return;
		}

		if (returnedToOriginal) {
			// Value original par wapas — edit-mode band karo aur pending flag bhi hata do.
			setIsEditFinalProduction((prev) => {
				const next = { ...prev };
				delete next[elementId];
				return next;
			});
			return;
		}

		handleFinalProductionEditClick(elementId);
	};

	const handlePasteProductionPlan = async () => {
		try {
			if (!navigator?.clipboard?.readText) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Clipboard read is not supported in this browser. Try Chrome/Edge.',
				});
				return;
			}
			const raw = await navigator.clipboard.readText();
			if (!raw || !raw.trim()) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Clipboard is empty. Copy the rows from Excel first.',
				});
				return;
			}
			const lines = raw
				.split(/\r?\n/)
				.map((l) => l.trim())
				.filter(Boolean);
			const dataLines = lines[0] && /product\s*name/i.test(lines[0])
				? lines.slice(1)
				: lines;
			if (!dataLines.length) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'No data rows detected in the pasted content.',
				});
				return;
			}
			const variantByClientId = new Map();
			(products || []).forEach((p) => {
				(p?.variants || []).forEach((v) => {
					if (v?.clientVariantId) {
						variantByClientId.set(
							String(v.clientVariantId).toLowerCase().trim(),
							v.id
						);
					}
				});
			});

			const updatesByElementId = new Map();
			const unmatched = [];
			const currentType = selectedType?.value;
			const currentList = listData?.[currentType] || [];

			dataLines.forEach((line) => {
				const cells = line.split('\t').map((c) => (c || '').trim());
				const productName = cells[0] || '';
				const pastedSku = cells[1] || '';
				const qtyRaw = cells[3] || '';
				const qty = parseFloat(qtyRaw.replace(/,/g, ''));
				if (Number.isNaN(qty)) {
					unmatched.push(productName || pastedSku || '(empty row)');
					return;
				}
				let clientId = String(pastedSku).toLowerCase().trim();
				if (!clientId && productName.includes('-')) {
					clientId = productName.slice(productName.lastIndexOf('-') + 1).toLowerCase().trim();
				}
				const variantId = clientId ? variantByClientId.get(clientId) : null;
				if (variantId == null) {
					unmatched.push(productName || pastedSku);
					return;
				}
				const matchedItem = currentList.find((ele) => ele?.variantId === variantId);
				if (!matchedItem) {
					unmatched.push(productName || pastedSku);
					return;
				}
				updatesByElementId.set(getElementId(matchedItem), qty);
			});

			if (updatesByElementId.size === 0) {
				notificationServices.generateNotification({
					type: 'warning',
					message: 'No matching products found for the pasted rows.',
				});
				return;
			}
			setListData((prev) => {
				const next = { ...prev };
				next[currentType] = (next[currentType] || []).map((ele) => {
					const eid = getElementId(ele);
					if (!updatesByElementId.has(eid)) return ele;
					const higherQty = updatesByElementId.get(eid);
					const lowerUnitValue = higherQty !== ''
						? convertToLowerUnit(ele?.unit, higherQty)
						: higherQty;
					const deltaValue = ele?.updatedQty === ele?.orderedQty
						? 0
						: ele?.updatedQty - ele?.orderedQty;
					const nonAdjustQty = ele?.calculatedQtyNonAdjusted < 0
						? Math.abs(parseFloat(ele?.calculatedQtyNonAdjusted))
						: 0;
					const oldDeltaValue = ele?.delta ? ele?.delta : deltaValue;
					const initialLowerQty = ele.prevTempProductionValue
						? convertToLowerUnit(ele?.unit, ele.prevTempProductionValue)
						: 0;
					const newDelta = (oldDeltaValue + (lowerUnitValue - initialLowerQty)) + nonAdjustQty;
					return {
						...ele,
						finalProduction: lowerUnitValue,
						tempProductionValue: String(higherQty),
						prevTempProductionValue: String(higherQty),
						delta: newDelta,
					};
				});
				return next;
			});

			if (updatesByElementId.size > 0) {
				setIsEditFinalProduction((prev) => {
					const nextEdit = { ...prev };
					for (const eid of updatesByElementId.keys()) {
						nextEdit[eid] = true;
					}
					return nextEdit;
				});
			}

			notificationServices.generateNotification({
				type: 'success',
				message: `Updated ${updatesByElementId.size} product${updatesByElementId.size > 1 ? 's' : ''} from clipboard${unmatched.length ? `, ${unmatched.length} skipped` : ''}.`,
			});
			if (unmatched.length > 0) {
				const sample = unmatched.slice(0, 5).join(', ');
				const remaining = unmatched.length - 5;
				notificationServices.generateNotification({
					type: 'warning',
					message: `Could not match: ${sample}${remaining > 0 ? ` and ${remaining} more` : ''}.`,
				});
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error('Paste plan failed:', e);
			notificationServices.generateNotification({
				type: 'error',
				message: 'Could not read clipboard. Allow clipboard access and copy the rows again.',
			});
		}
	};

	const handleQtyChange = (e, elementId) => {
		setListData((prev) => {
			const temp = {
				...prev,
			};
			temp[selectedType?.value] = temp[selectedType?.value]?.map(
				(ele) => {
					if (elementId === getElementId(ele)) {
						// User enters in higher unit (kg/ltr), convert to lower unit (gm/ml) for storage
						const inputValue = e?.target.value;
						const lowerUnitValue = inputValue !== '' && inputValue !== null
							? convertToLowerUnit(ele?.unit, inputValue)
							: inputValue;
						return {
							...ele,
							delta: lowerUnitValue,
							deltaHigherUnit: inputValue, // Store higher unit value for display
						};
					}
					return ele;
				}
			);
			return {
				...temp,
			};
		});
	};

	const handlePacksOrderedChange = (e, elementId) => {
		const value = e?.target.value;
		setListData((prev) => {
			const temp = {
				...prev,
			};
			temp.PACKAGING = temp.PACKAGING?.map((ele) => {
				if (elementId === getElementId(ele)) {
					return {
						...ele,
						updatedPacksToBePacked: value,
					};
				}
				return ele;
			});
			return {
				...temp,
			};
		});
	};

	const handleProcessChange = (value, id) => {
		setListData((prev) => {
			const temp = { ...prev };
			temp[selectedType?.value] = temp[selectedType?.value]?.map((ele) => {
				if (id === getElementId(ele)) {
					return { ...ele, toProcessId: value };
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const handleReasonChange = (value, id) => {
		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;
			temp[currentType] = temp[currentType]?.map((ele) => {
				if (id === getElementId(ele)) {
					const selectedReason = reasonList.find((r) => String(r.id) === String(value));
					return {
						...ele,
						reasonId: value,
						...(selectedReason?.value !== 'Other' ? { customReasonInput: '' } : {}),
					};
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const handleCustomReasonInputChange = (value, id) => {
		setListData((prev) => {
			const temp = { ...prev };
			const currentType = selectedType?.value;
			temp[currentType] = temp[currentType]?.map((ele) => {
				if (id === getElementId(ele)) {
					return { ...ele, customReasonInput: value };
				}
				return ele;
			});
			return { ...temp };
		});
	};

	const handleAddRecipe = (id) => {
		history.push(`/console2/kitchen/cooking/recipe/view/${id}`);
	};

	const getStatus = (type, lowStock, threshold) => {
		if (type === 'Ingredient') {
			if (lowStock && threshold === 0) {
				return (
					<p className='text-xs font-medium bg-blue-200 rounded-full px-2.5 py-0.5 inline-flex items-center gap-1 justify-center w-fit'>
						Freshly Procure
					</p>
				);
			}
			if (lowStock && threshold !== 0) {
				return (
					<p className='text-xs font-medium bg-red-200 rounded-full px-2.5 py-0.5 inline-flex items-center gap-1 justify-center w-fit'>
						<ArrowDownward
							style={{
								color: '#EF4444',
								width: '16px',
								height: '16px',
							}}
						/>
						Low Stock
					</p>
				);
			}
			if (!lowStock) {
				return (
					<p className='text-xs font-medium bg-green-200 rounded-full px-2.5 py-0.5 inline-flex items-center gap-1 justify-center w-fit'>
						In Stock
					</p>
				);
			}
		}
		if (type === 'Product') {
			if (lowStock) {
				return (
					<p className='text-xs font-medium bg-red-200 rounded-full px-2.5 py-0.5 inline-flex items-center gap-1 justify-center w-fit'>
						<ArrowDownward
							style={{
								color: '#EF4444',
								width: '16px',
								height: '16px',
							}}
						/>
						Low Stock
					</p>
				);
			}
			if (!lowStock) {
				return (
					<p className='text-xs font-medium bg-green-200 rounded-full px-2.5 py-0.5 inline-flex items-center gap-1 justify-center w-fit'>
						In Stock
					</p>
				);
			}
		}
		if (type === 'Intermediate') {
			if (lowStock) {
				return (
					<p className='text-xs font-medium bg-red-200 rounded-full px-2.5 py-0.5 inline-flex items-center gap-1 justify-center w-fit'>
						<ArrowDownward
							style={{
								color: '#EF4444',
								width: '16px',
								height: '16px',
							}}
						/>
						Low Stock
					</p>
				);
			}
			if (!lowStock) {
				return (
					<p className='text-xs font-medium bg-green-200 rounded-full px-2.5 py-0.5 inline-flex items-center gap-1 justify-center w-fit'>
						In Stock
					</p>
				);
			}
		}
		return '-';
	};

	const handleToggleSkipMeasurement = (value, id) => {
		const product = listData?.[selectedType?.value]?.find((prod) => {
			return getElementId(prod) === id;
		});

		if (product?.productId) {
			setSkipMeasurementToggles((prev) => ({
				...prev,
				[product.productId]: value,
			}));
		}
	};

	// NaN/undefined cell values render as '-' instead of leaking "NaN" into the table
	const toDisplay = (val) => {
		if (val === null || val === undefined || val === '') return '-';
		if (typeof val === 'number' && Number.isNaN(val)) return '-';
		if (typeof val === 'string' && val.includes('NaN')) return '-';
		return val;
	};

	// Display unit: a count product's sub-unit (e.g. "Pax") when it has one, else the usual
	// higher unit (pcs / kg / ltr).
	const displayUnitOf = (product) => {
		const [, unit] = getHigherUnitAndQuantity(product?.unit, 0);
		if (getUnitFamily(product?.unit) === 'count') {
			const subUnitName = products?.find((val) => val?.id === product?.productId)?.subUnitName;
			if (subUnitName) return subUnitName;
		}
		return unit;
	};

	// "= 4.8 kg": what a count of a count product weighs, from its variant's minWeight (grams).
	// null when it is not a count product, has no minWeight, or the count is not positive.
	const variantMinWeight = (product) => {
		if (getUnitFamily(product?.unit) !== 'count') return null;
		const variant = products
			?.find((val) => val?.id === product?.productId)
			?.variants?.find((v) => v?.id === product?.variantId);
		const minWeight = Number(variant?.minWeight);
		return minWeight > 0 ? minWeight : null;
	};
	const countWeightText = (product, count) => {
		const n = Number(count);
		const minWeight = variantMinWeight(product);
		if (!minWeight || !(n > 0)) return null;
		return `= ${Math.round((n * minWeight) / 1000 * 1000) / 1000} kg`;
	};
	// "120 g per Pax" under a count product's name.
	const perUnitWeightText = (product) => {
		const minWeight = variantMinWeight(product);
		return minWeight ? `${Math.round(minWeight * 1000) / 1000} g per ${displayUnitOf(product)}` : null;
	};

	const formatQtyByUnit = (unit, value) => {
		const n = Number(value);
		if (value === null || value === undefined || value === '' || Number.isNaN(n)) return value;
		return getUnitFamily(unit) === 'count'
			? Math.round(n * 100) / 100
			: n.toFixed(2);
	};

	const SPECIAL_ITEMS = {
		[`Planned For Consumption ${plannedDate}`]: (product) => {
			const value = parseFloat(product?.plannedForConsumption);
			return Number.isNaN(value) ? '-' : value.toFixed(2);
		},
		[`Planned To be Received on ${plannedDate}`]: (product) => {
			const value = parseFloat(product?.plannedToBeReceived);
			return Number.isNaN(value) ? '-' : value.toFixed(2);
		},
		'Product Name': (product) => {
			const id = product?.id;
			return (
				<div className='flex items-start gap-1 flex-col'>
					<span>
						{product?.productName}
						{product?.variantName && (
							<span className='text-xs font-medium rounded-md p-1 ml-1 bg-blue-200'>
								{product?.variantName}
							</span>
						)}
					</span>
					{perUnitWeightText(product) && (
						<span className='text-[11px] text-gray-500'>{perUnitWeightText(product)}</span>
					)}
				</div>
			);
		},
		Reason: (product) => {
			const id = product?.id;
			if ((Array.isArray(reasonList) && reasonList?.length === 0) || !reasonList) return '-';
			const isProductOrIntermediate =
				selectedType?.value === 'PRODUCT' ||
				selectedType?.value === 'INTERMEDIATE';
			const hasChangedDelta = (product?.delta != null && product?.delta !== 0) || product?.reasonId;

			if (!isProductOrIntermediate || !hasChangedDelta) {
				return <span className='text-gray-400'>-</span>;
			}

			const needsReason = !product?.reasonId;
			const selectedReason = reasonList.find((r) => String(r.id) === String(product?.reasonId));
			const isOther = selectedReason?.value === 'Other';

			if (data?.nonEditable) {
				return (
					<div className='text-xs'>
						{selectedReason?.value ?? '-'}
						{isOther && product?.customReasonInput && ` (${product.customReasonInput})`}
					</div>
				);
			}

			return (
				<div className={`w-full min-w-[150px] ${needsReason ? 'rounded-md p-1 bg-red-50 border border-red-300 animate-pulse' : ''}`}>
					<SelectPicker
						data={reasonList.map((reason) => ({
							label: reason.value,
							value: String(reason.id),
						}))}
						placeholder='Select Reason'
						className={`w-full ${needsReason ? 'border-red-400 ring-1 ring-red-300' : ''}`}
						value={String(product?.reasonId || '')}
						onChange={(value) => handleReasonChange(value, id)}
						cleanable={false}
						searchable={true}
						menuClassName='z-[99999]'
					/>
					{isOther && (
						<Input
							className='mt-1 h-8 text-xs'
							placeholder='Enter reason'
							value={product?.customReasonInput || ''}
							onChange={(e) =>
								handleCustomReasonInputChange(e.target.value, id)
							}
							disabled={data?.nonEditable}
						/>
					)}
				</div>
			);
		},
		'Kit Batch Size': (product) => {
			const id = product?.id;
			if (product?.kitBatchSize == null) return '-';
			const [kitBatchSize, _] = getHigherUnitAndQuantity(product?.unit, product?.kitBatchSize);
			return kitBatchSize;
		},
		'Kit Count': (product) => {
			const id = product?.id;
			return product?.kitCount ?? '-';
		},
		'Labelling Date': (product) => {
			const id = product?.id;
			return product?.labellingDate ?? '-';
		},
		'Scheduled Date': (product) => {
			const id = product?.id;
			return product?.scheduledDate ?? '-';
		},
		'Measure Quantity': (product) => {
			const id = product?.id;
			const skipMeasurement = skipMeasurementToggles[product?.productId] || false;
			return (
				<div className='flex flex-1 items-center gap-1 justify-center'>
					<div className='relative'>
						{/* Toggle Container */}
						<div className='flex items-center border border-gray-300 rounded-lg p-1 bg-white relative'>
							{/* Sliding Background */}
							<div
								className={`absolute top-1 bottom-1 w-8 h-6 rounded-md transition-all duration-300 ease-in-out ${!skipMeasurement
									? 'bg-green-500 left-1'
									: 'bg-red-200 left-9'
									}`}
							/>

							{/* Weight Button */}
							<button
								onClick={() =>
									handleToggleSkipMeasurement(false, id)
								}
								disabled={data?.nonEditable}
								className={`relative flex items-center justify-center w-8 h-6 rounded-md transition-all duration-200 ${data?.Editable ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'
									}`}
								title="Weight"
							>
								<img
									src={weight}
									alt='weight'
									className={`w-4 h-4 transition-all duration-200 ${!skipMeasurement ? 'filter brightness-0' : 'filter brightness-75'
										}`}
								/>
							</button>

							{/* No Weight Button */}
							<button
								onClick={() =>
									handleToggleSkipMeasurement(true, id)
								}
								disabled={data?.nonEditable}
								className={`relative flex items-center justify-center w-8 h-6 rounded-md transition-all duration-200 ${data?.nonEditable ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'
									}`}
								title="No Weight"
							>
								<img
									src={noWeight}
									alt='no weight'
									className={`w-4 h-4 transition-all duration-200 ${skipMeasurement ? 'filter brightness-0' : 'filter brightness-75'
										}`}
								/>
							</button>
						</div>
					</div>
				</div>
			);
		},
		Unit: (product) => displayUnitOf(product),
		Category: (product) => {
			const id = product?.id;
			return (
				products?.find((val) => val?.id === product?.productId)
					?.categoryName ?? '-'
			);
		},
		'Sub Category': (product) => {
			const id = product?.id;
			return (
				products?.find((val) => val?.id === product?.productId)
					?.subCategoryName ?? '-'
			);
		},
		'SKU Code': (product) => {
			const id = product?.id;
			return (
				products
					?.find((val) => val?.id === product?.productId)
					?.variants?.find(
						(variant) => variant?.id === product?.variantId
					)?.clientVariantId ?? '-'
			);
		},
		'From Process': (product) => {
			const id = product?.id;
			return product?.fromProcess;
		},
		'To Process': (product) => {
			const id = product?.id;
			return product?.toProcess;
		},
		'Select Yield Process': (product) => {
			const id = product?.id;
			if (data?.nonEditable || Number(appConfig?.customerId) === 72) {
				const process = processList?.find((ele) => {
					return Number(ele?.id) === Number(product?.toProcessId);
				});
				return <div className='flex items-center gap-1'>{process?.data?.heading ?? ''}({process?.data?.sectionName ?? ''})</div>
			}
			return (
				<SelectPicker
					data={processList?.map((ele) => ({
						label: `${ele?.data?.heading ?? ''}(${ele?.data?.sectionName ?? ''})`,
						value: ele?.id,
					}))}
					placeholder='Select Yield Process'
					className='w-[140px]'
					value={product?.toProcessId != null ? Number(product?.toProcessId) : null}
					onChange={(value) => handleProcessChange(value, id)}
					cleanable={true}
					searchable={true}
					disabled={Number(appConfig?.customerId) === 52}
					menuClassName='z-[99999]'
				/>
			);
		},
		Scheduled: (product) => {
			const id = product?.id;
			let str = '';
			if (product?.scheduledAtDelta) {
				if (product?.scheduledAtDelta < 0) {
					str = 'T' + product?.scheduledAtDelta;
				} else if (product?.scheduledAtDelta === 0) {
					str = 'T';
				} else {
					str = 'T+' + product?.scheduledAtDelta;
				}
			}
			return str;
		},
		[`Stock At ${stockCheckedAt}`]: (product) => {
			const id = product?.id;
			const [stock, _] = getHigherUnitAndQuantity(product?.unit, product?.stock);
			return stock;
		},
		[`Projected Stock at ${nextStockCheckAtDate} 7:59 AM`]: (product) => {
			const id = product?.id;
			if (product?.prePlanStock == null) return '-';
			const [prePlanStock, _] = getHigherUnitAndQuantity(product?.unit, product?.prePlanStock);
			return prePlanStock;
		},
		[`Minimum Stock at ${nextStockCheckAtDate} 7:59 AM`]: (product) => {
			const id = product?.id;
			const [threshold, _] = getHigherUnitAndQuantity(product?.unit, product?.threshold);
			return threshold;
		},
		[`Order Quantity PO Delivery Date ${scheduledFor}`]: (product) => {
			const id = product?.id;
			if (data?.lppId && poOrderFetched && poOrderQtyMap[product?.variantId] == null) {
				return '-';
			}
			const value = data?.lppId && poOrderFetched && poOrderQtyMap?.[product?.variantId]
				? parseFloat(product?.orderedQty)?.toFixed(2)
				: getHigherUnitAndQuantity(product?.unit, product?.orderedQty)[0];
			return value ?? '-';
		},
		'Pre Batch Production Quantity': (product) => {
			const id = product?.id;
			const [calculatedQty, calculatedQtyUnit] = getHigherUnitAndQuantity(product?.unit, product?.calculatedQty);
			const [calculatedQtyNonAdjusted, calculatedQtyNonAdjustedUnit] = getHigherUnitAndQuantity(product?.unit, product?.calculatedQtyNonAdjusted);
			const plannedText =
				formatQtyByUnit(product?.unit, calculatedQty) +
				(calculatedQtyNonAdjusted < 0
					? // eslint-disable-next-line prefer-template
					'(' + formatQtyByUnit(product?.unit, calculatedQtyNonAdjusted) + ')'
					: '');
			const showApply = data?.lppId && !data?.nonEditable && !data?.finalProductionNonEditable && selectedType?.value === 'PRODUCT'
			return (
				<div className='flex items-center gap-1.5'>
					<span>{toDisplay(plannedText)}</span>
					{showApply && (
						<Tooltip title='Use this as Final Production (rounded up to full batches)'>
							<span
								className='inline-flex items-center gap-0.5 cursor-pointer text-blue-600 hover:text-blue-800'
								onClick={() => applyPlannedToFinal(id)}
							>
								<ArrowRightToLine size={16} />
								<Factory size={14} />
							</span>
						</Tooltip>
					)}
				</div>
			);
		},
		// 'Stock Info': (id) => {
		// 	const product = listData?.[selectedType?.value]?.find((prod) => {
		// 		return getElementId(prod) === id;
		// 	});
		// 	return (
		// 		<div className='flex items-center justify-center flex-row gap-1'>
		// 			<div className='flex flex-col items-center gap-2'>
		// 				{
		// 					![undefined, null].includes(product?.stock) && (
		// 						<span className='text-xs font-medium bg-gray-200 p-1 rounded-md'>{product?.stock}</span>
		// 					)
		// 				}
		// 				{
		// 					![undefined, null].includes(product?.totalRequiredQty) && (
		// 						<span className='text-xs font-medium bg-blue-200 p-1 rounded-md'>{Number(product?.totalRequiredQty ?? 0).toFixed(0)}</span>
		// 					)
		// 				}
		// 			</div>
		// 			{product?.lowStock && (
		// 			<div className='flex items-center gap-2'>
		// 				<ArrowDownward style={{ color: '#EF4444', width: '16px', height: '16px' }} />
		// 			</div>
		// 				)}
		// 		</div>
		// );
		// },
		'Required Stock': (product) => {
			const id = product?.id;
			const [totalRequiredQty, _] = getHigherUnitAndQuantity(product?.unit, product?.totalRequiredQty);
			return Number(totalRequiredQty ?? 0).toFixed(2);
		},
		'Current Stock': (product) => {
			const id = product?.id;
			const [stock, _] = getHigherUnitAndQuantity(product?.unit, product?.stock);
			return Number(stock ?? 0).toFixed(2);
		},
		'Recommended Production Qty': (product) => {
			const id = product?.id;
			const recommended = getRecommendedQty(product);
			const [value] = getHigherUnitAndQuantity(product?.unit, recommended);
			const showApply = data?.lppId && !data?.nonEditable && !data?.finalProductionNonEditable && selectedType?.value === 'PRODUCT';
			return (
				<div className='flex items-center gap-1.5'>
					<span>{toDisplay(formatQtyByUnit(product?.unit, value ?? 0))}</span>
					{showApply && (
						<Tooltip title='Use this as Final Production (rounded up to full batches)'>
							<span
								className='inline-flex items-center gap-0.5 cursor-pointer text-blue-600 hover:text-blue-800'
								onClick={() => applyRecommendedToFinal(id)}
							>
								<ArrowRightToLine size={16} />
								<Factory size={14} />
							</span>
						</Tooltip>
					)}
				</div>
			);
		},
		Status: (product) => {
			const id = product?.id;
			if (selectedType?.value === 'INGREDIENT') {
				return getStatus(
					'Ingredient',
					product?.lowStock,
					product?.threshold
				);
			}
			if (selectedType?.value === 'PRODUCT') {
				return getStatus(
					'Product',
					product?.lowStock,
					product?.threshold
				);
			}
			if (selectedType?.value === 'INTERMEDIATE') {
				return getStatus(
					'Intermediate',
					product?.lowStock,
					product?.threshold
				);
			}
			return '-';
		},
		'Wastage %': (product) => {
			const id = product?.id;
			return product?.wastage ?? '-';
		},
		'Possible Production Qty': (product) => {
			const id = product?.id;
			const [suggestedQty, _] = getHigherUnitAndQuantity(product?.unit, product?.suggestedQty);
			if (selectedType?.value === 'PRODUCT') {
				if (product?.orderedQty > product?.suggestedQty) {
					return (
						<span className='font-medium text-red-600'>
							{toDisplay(formatQtyByUnit(product?.unit, suggestedQty))}
						</span>
					);
				}
				return (
					<span className='font-medium'>
						{toDisplay(formatQtyByUnit(product?.unit, suggestedQty))}
					</span>
				);
			}
			return toDisplay(formatQtyByUnit(product?.unit, suggestedQty));
		},
		'Batch Size': (product) => {
			const id = product?.id;
			const [batchSize, _] = getHigherUnitAndQuantity(product?.unit, product?.batchSize);
			if (batchSize) {
				return batchSize;
			}
			return !data?.hideButtons && <Button onClick={() => window.open(`${urls.EXTENSION}${urls.VARIANT_BATCH_SIZE}?productId=${product?.productId}&variantId=${product?.variantId}&storeId=${data?.storeId}&productName=${product?.productName + (product?.variantName ? ` (${product?.variantName})` : '')}`)} className='px-2 h-6 text-[11px] bg-blue-400 hover:bg-blue-500 text-white' > Add Batch Size</Button>;
		},
		'Final Production': (product) => {
			const id = product?.id;
			const [finalProduction, _] = getHigherUnitAndQuantity(product?.unit, product?.finalProduction);
			const initialHigher = product?.initialProductionQty ? getHigherUnitAndQuantity(product?.unit, product?.initialProductionQty)[0] : '';
			const isInlineEditable = !data?.nonEditable
				&& !data?.finalProductionNonEditable
				&& !product?.notScheduled
				&& (
					(['70', '73'].includes(String(appConfig?.customerId))
						&& selectedType?.value === 'PRODUCT')
					|| !!data?.lppId
				);
			if (isInlineEditable) {
				const tempFinalProductionHigher = product?.tempProductionValue ? product?.tempProductionValue : '';
				const editWeight = countWeightText(product, tempFinalProductionHigher);
				return (
					<div>
						<p className='text-xs text-gray-600 mb-1'>Initial: {initialHigher}</p>
						<Input
							type='number'
							min='0'
							value={tempFinalProductionHigher}
							onChange={(e) => handleFinalProductionChange(e, id)}
							onBlur={() => handleFinalProductionSave(id)}
							onFocus={() => handleFinalProductionEditClick(getElementId(product))}
						/>
						{editWeight && <p className='text-[10px] text-gray-500 mt-0.5'>{editWeight}</p>}
					</div>
				);
			}
			const finalWeight = countWeightText(product, finalProduction);
			return (
				<div>
					{toDisplay(formatQtyByUnit(product?.unit, finalProduction))}
					{finalWeight && <p className='text-[10px] text-gray-500'>{finalWeight}</p>}
				</div>
			);
		},
		'Final Indent': (product) => {
			const id = product?.id;
			const [finalProduction, _] = getHigherUnitAndQuantity(product?.unit, product?.finalProduction);
			return toDisplay(Number(finalProduction).toFixed(3));
		},
		[`Plan ${stockCheckAtDate} Planned Production`]: (product) => {
			const id = product?.id;
			const [currentDayCount, _] = getHigherUnitAndQuantity(product?.unit, product?.currentDayCount);
			return currentDayCount;
		},
		[`Plan ${stockCheckAtDate} Produced till ${stockCheckedAt}`]: (product) => {
			const id = product?.id;
			const [currentDayStockIn, _] = getHigherUnitAndQuantity(product?.unit, product?.currentDayStockIn);
			return currentDayStockIn;
		},
		'Forecast for Next 7 Days': (product) => {
			const id = product?.id;
			if (product?.forecasted == null) return '-';
			const [forecasted, _] = getHigherUnitAndQuantity(product?.unit, product?.forecasted);
			return forecasted;
		},
		'Left Over (From Executed plans)': (product) => {
			const id = product?.id;
			if (product?.leftOver == null) return '-';
			const [leftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.leftOver);
			return leftOver;
		},
		'Left Over (Already Planned)': (product) => {
			const id = product?.id;
			if (product?.plannedLeftOver == null) return '-';
			const [plannedLeftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.plannedLeftOver);
			return plannedLeftOver;
		},
		'Pre Batch Without Left Over': (product) => {
			const id = product?.id;
			if (product?.calculatedQtyNonAdjusted == null) return '-';
			const [calculatedQtyNonAdjusted, _] = getHigherUnitAndQuantity(product?.unit, product?.calculatedQtyNonAdjusted);
			return calculatedQtyNonAdjusted;
		},
		'Left Over (Used/Input)': (product) => {
			const id = product?.id;
			if (!product?.leftOver || !product?.inputLeftOver) return '-';
			const [leftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.leftOver);
			const [inputLeftOver, __] = getHigherUnitAndQuantity(product?.unit, product?.inputLeftOver);
			return leftOver + '/' + inputLeftOver;
		},
		'Left Over (Input)': (product) => {
			const id = product?.id;
			if (product?.stock == null) return '-';
			const [stock, _] = getHigherUnitAndQuantity(product?.unit, product?.stock);
			return stock;
		},
		[`Plan ${stockCheckAtDate} Planned Extra Production`]: (product) => {
			const id = product?.id;
			if (product?.extraScheduled == null) return '-';
			const [extraScheduled, _] = getHigherUnitAndQuantity(product?.unit, product?.extraScheduled);
			return extraScheduled;
		},
		'Expected Left Over': (product) => {
			const id = product?.id;
			if (product?.expectedLeftOver == null) return '-';
			const [expectedLeftOver, _] = getHigherUnitAndQuantity(product?.unit, product?.expectedLeftOver);
			return expectedLeftOver;
		},
		'Production Factor (+/- Manual Calibration)': (product) => {
			const id = product?.id;
			const initialProductData = prevListData?.[selectedType?.value]?.find((prod) => {
				return getElementId(prod) === id;
			});

			// Convert to higher unit for display
			const [initialValueHigher, _] = getHigherUnitAndQuantity(
				product?.unit,
				product?.updatedQty === product?.orderedQty
					? 0
					: product?.updatedQty - product?.orderedQty
			);

			const hasError = Number(product?.delta) < -initialProductData?.calculatedQty;

			let minPossible;
			if (initialProductData && initialProductData?.delta) {
				minPossible = Number(product?.calculatedQty - Number(initialProductData?.delta));
			} else {
				minPossible = product?.calculatedQty;
			}

			// Convert minPossible to higher unit for display
			const [minPossibleHigher, __] = getHigherUnitAndQuantity(product?.unit, minPossible);

			// Get the display value for delta in higher unit
			const [deltaHigher, ___] = getHigherUnitAndQuantity(product?.unit, product?.delta);
			const [updatedQtyDiffHigher, ____] = getHigherUnitAndQuantity(
				product?.unit,
				product?.updatedQty - product?.orderedQty
			);
			const displayValue = product?.delta ? deltaHigher : (product?.updatedQty !== product?.orderedQty ? updatedQtyDiffHigher : 0);
			// 70/73 customers ya LPP mode me Production Factor read-only (non-editable) dikhega.
			if ((['70', '73'].includes(String(appConfig?.customerId)) || !!data?.lppId) && selectedType?.value === 'PRODUCT') {
				return (
					<div className='flex flex-col items-center justify-center text-center py-1'>
						<p className='text-[11px] text-gray-500 text-nowrap'>Min possible = -{toDisplay(minPossibleHigher)}</p>
						<p className='text-sm font-semibold mt-1.5 text-gray-800'>{toDisplay(displayValue)}</p>
					</div>
				);
			}

			if (isEdit[getElementId(product)]) {
				const inputDisplayValue = product?.deltaHigherUnit ?? (product?.delta != null ? deltaHigher : initialValueHigher);
				return (
					<div>
						<p className='text-xs text-gray-600 mb-1'>Min possible = -{minPossibleHigher}</p>
						<Input
							style={{
								outline: hasError ? 'none' : '',
								border: hasError ? '2px solid red' : '',
								color: hasError ? 'red' : '',
							}}
							type='number'
							placeholder='Change Order QTY'
							value={inputDisplayValue}
							onChange={(e) => {
								handleQtyChange(e, id);
							}}
						/>
						<IconButton
							onClick={() => {
								if (hasError) {
									notificationServices.generateNotification({
										type: 'warning',
										message: 'Please check value',
									});
									return;
								}
								handleEditClick(getElementId(product));
							}}
						>
							<CheckCircle />
						</IconButton>
					</div>
				);
			}
			return (
				<span className={styles['order-qty']}>
					{/* <s className={styles.actual}>{product?.orderedQty}</s> */}
					<p>{toDisplay(displayValue)}</p>
					{(!data?.nonEditable && !product?.notScheduled) && (
						<IconButton
							onClick={() => {
								handleEditClick(getElementId(product));
							}}
							className={styles['edit-btn']}
						>
							<ModeEdit />
						</IconButton>
					)}
				</span>
			);
		},
		'Recipe Exists': (product) => {
			const id = product?.id;

			return !product?.skipped ? (
				<Check />
			) : (
				<div className={styles['no-recipe']}>
					<HighlightOff />
					<IconButton
						onClick={() => {
							handleAddRecipe(product?.productId);
						}}
						className={styles['add-recipe']}
						disabled={product?.notScheduled === true}
					>
						<AddCircle className={styles.icon} />
						<p>Add Recipe</p>
					</IconButton>
				</div>
			);
		},
		'Recipe Status': (product) => {
			const id = product?.id;
			const statusMap = listData?.recipeApprovalStatus;
			// Show value only if this product has an entry in the map
			const status = statusMap?.[product?.productId];
			if (!status) return '-';
			const normalized = String(status).toUpperCase();
			const styleByStatus = {
				APPROVED: 'bg-green-100 text-green-700 border-green-300',
				PENDING: 'bg-yellow-100 text-yellow-700 border-yellow-300',
				REJECTED: 'bg-red-100 text-red-700 border-red-300',
			};
			const chipClass = styleByStatus[normalized] || 'bg-gray-100 text-gray-700 border-gray-300';
			return (
				<span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${chipClass}`}>
					{normalized}
				</span>
			);
		},
		'No of batches': (product) => {
			const id = product?.id;
			return product?.batchCount ?? '-';
		},
		'Shift ID': (product) => {
			const id = product?.id;
			return product?.shiftId ?? '-';
		},
		'Shift Name': (product) => {
			const id = product?.id;
			return product?.shiftName ?? '-';
		},
		'Parent Product': (product) => {
			const id = product?.id;
			return product?.parentProduct ?? '-';
		},
	};

	// Packaging-specific special items
	const PACKAGING_SPECIAL_ITEMS = {
		'Item Name': (product) => {
			const id = product?.id;
			return (
				<div className='flex items-start gap-1 flex-col'>
					<span>
						{product?.productName}
						{product?.variantName && (
							<span className='text-xs font-medium bg-blue-200 rounded-md p-1 ml-1'>
								{product?.variantName}
							</span>
						)}
					</span>
				</div>
			);
		},
		'Item Code': (product) => {
			const id = product?.id;
			return product?.itemCode ?? product?.variantId ?? '-';
		},
		'Pack Size': (product) => {
			const id = product?.id;
			return (
				<div className='flex items-center gap-1'>
					<span className='text-xs font-medium bg-yellow-100 text-yellow-700 rounded-md px-2 py-1'>
						{product?.packName ||
							`Pack of ${product?.packSize || product?.batchSize || '-'
							}`}
					</span>
				</div>
			);
		},
		'Production Factor (+/- Manual Calibration)': (product) => {
			const id = product?.id;
			return product?.productionFactor ?? 1;
		},
		'Packs Ordered': (product) => {
			const id = product?.id;
			const originalPacksOrdered =
				product?.packsOrdered ?? product?.orderedQty ?? 0;
			const displayValue =
				product?.updatedPacksToBePacked !== undefined
					? product?.updatedPacksToBePacked
					: originalPacksOrdered;

			const hasError = Number(displayValue) < 0;

			if (isEdit[getElementId(product)]) {
				return (
					<div>
						<Input
							style={{
								outline: hasError ? 'none' : '',
								border: hasError ? '2px solid red' : '',
								color: hasError ? 'red' : '',
							}}
							type='number'
							min='0'
							placeholder='Enter Packs Ordered'
							value={displayValue}
							onChange={(e) => {
								handlePacksOrderedChange(
									e,
									getElementId(product)
								);
							}}
						/>
						<IconButton
							onClick={() => {
								if (hasError) {
									notificationServices.generateNotification({
										type: 'warning',
										message:
											'Packs Ordered cannot be negative',
									});
									return;
								}
								handleEditClick(getElementId(product));
							}}
						>
							<CheckCircle />
						</IconButton>
					</div>
				);
			}
			return (
				<span className={styles['order-qty']}>
					<p>{displayValue}</p>
					{!data?.nonEditable && (
						<IconButton
							onClick={() => {
								handleEditClick(getElementId(product));
							}}
							className={styles['edit-btn']}
						>
							<ModeEdit />
						</IconButton>
					)}
				</span>
			);
		},
		'Available Packs in Stock': (product) => {
			const id = product?.id;
			return product?.availablePacks ?? product?.stock ?? '-';
		},
		'Packs to be packed': (product) => {
			const id = product?.id;
			return product?.packsToBePacked ?? product?.finalProduction ?? '-';
		},
		'Qty of SKU required': (product) => {
			const id = product?.id;
			return product?.qtyOfSkuRequired ?? product?.calculatedQty ?? '-';
		},
	};

	const getRowStyles = (ele) => {
		if (ele?.notScheduled === true) {
			return styles.notScheduledRow;
		}
		if (ele?.scheduledAtDelta > 0) {
			return styles.deltaHigh;
		}
		if (ele?.updatedQty !== null && ele?.updatedQty !== ele?.orderedQty) {
			return styles.updated;
		}
		if (ele?.skipped && selectedType?.value !== 'INGREDIENT') {
			return styles.skipped;
		}
		return '';
	};

	const handleSelectType = (e, value) => {
		if (value) {
			setSelectedType(value);
		}
	};

	const DATA = useMemo(() => {
		// getElementId INGREDIENT rows ke liye unique nahi hota (same variant/parent/
		// process/shift par multiple recipe lines aa sakti hain — sirf qty alag). Duplicate
		// React keys VariantTable ki row reconciliation todte hain (rows replicate hote hain
		// aur tab switch par stale rows reh jaate hain). Isliye `id` semantic hi rakho
		// (edit-matching ispe depend karta hai) aur React ke liye ek alag unique `rowKey` do.
		const seen = {};
		return (listData?.[selectedType?.value] ?? [])
			?.filter((ele) => {
				const query = searchQuery?.toLowerCase()?.trim();
				if (!query) return true;
				return (
					(ele?.productName ?? '').toLowerCase().includes(query)
					|| (ele?.parentProduct ?? '').toLowerCase().includes(query)
				);
			})
			// Sort the list by Parent Product Name (falls back to Product Name
			// when a row has no parent, e.g. top-level PRODUCT rows).
			?.sort((a, b) => {
				const keyOf = (ele) =>
					String(
						ele?.parentProduct && ele?.parentProduct !== '-'
							? ele.parentProduct
							: ele?.productName ?? ''
					);
				return keyOf(a).localeCompare(keyOf(b), undefined, {
					sensitivity: 'base',
					numeric: true,
				});
			})
			?.map((ele) => {
				const rowStyles = getRowStyles(ele);
				const isNotScheduled = ele?.notScheduled === true;
				const styleCss = isNotScheduled ? {
					background: 'linear-gradient(to bottom, transparent 0%, transparent calc(50% - 0.5px), #000 calc(50% - 0.5px), #000 calc(50% + 0.5px), transparent calc(50% + 0.5px), transparent 100%)'
				} : undefined;
				const baseId = getElementId(ele);
				const occurrence = seen[baseId] ?? 0;
				seen[baseId] = occurrence + 1;
				return {
					...ele,
					id: baseId,
					rowKey: occurrence === 0 ? baseId : `${baseId}#${occurrence}`,
					rowStyles,
					styleCss,
					// VariantTable consumes these generic per-row hooks.
					rowClassName: rowStyles,
					rowStyle: styleCss,
				};
			});
	}, [listData, selectedType, searchQuery]);

	const handleExport = () => {
		const headers = SPECIAL_COLUMNS?.map((ele) => {
			return ele?.title;
		})?.filter((ele) => {
			return ele !== 'Final Indent' && ele !== 'Recipe Exists' && ele !== 'Recipe Status';
		});
		headers?.splice(1, 0, ...['Variant Name', 'Sku Type']);
		const totalValues = [];
		const exportData = [
			...(listData?.PRODUCT ?? []),
			...(listData?.INTERMEDIATE ?? []),
			...(listData?.INGREDIENT ?? []),
			...(listData?.UNPACKED_PRODUCT ?? []),
		];
		exportData?.forEach((product) => {
			const delta =
				product?.updatedQty !== product?.orderedQty
					? product?.updatedQty - product?.orderedQty
					: 0;
			let str = '';
			if (product?.scheduledAtDelta) {
				if (product?.scheduledAtDelta < 0) {
					str = 'T' + product?.scheduledAtDelta;
				} else if (product?.scheduledAtDelta === 0) {
					str = 'T';
				} else {
					str = 'T+' + product?.scheduledAtDelta;
				}
			}
			const productInfo = products?.find(
				(val) => val?.id === product?.productId
			);
			const skuCode =
				productInfo?.variants?.find(
					(variant) => variant?.id === product?.variantId
				)?.clientVariantId ?? '-';
			const yieldProcess = processList?.find((ele) => {
				return Number(ele?.id) === Number(product?.toProcessId);
			});
			const yieldProcessLabel = yieldProcess
				? `${yieldProcess?.data?.heading ?? ''}(${yieldProcess?.data?.sectionName ?? ''})`
				: '-';
			const selectedReason = reasonList?.find(
				(r) => String(r.id) === String(product?.reasonId)
			);
			let reasonLabel = '-';
			if (selectedReason?.value) {
				reasonLabel =
					selectedReason?.value === 'Other' && product?.customReasonInput
						? `${selectedReason.value} (${product.customReasonInput})`
						: selectedReason.value;
			}
			let statusText = '-';
			if (product?.lowStock) {
				statusText =
					product?.productType === 'INGREDIENT' && product?.threshold === 0
						? 'Freshly Procure'
						: 'Low Stock';
			} else if (product?.lowStock === false) {
				statusText = 'In Stock';
			}
			// Convert quantities to the higher unit (g -> kg, ml -> ltr) exactly like the
			// table does via getHigherUnitAndQuantity. `higherUnit` is the display unit.
			const higherUnit =
				displayUnitOf(product) ??
				product?.unit ??
				'-';
			const conv = (v) =>
				v === null || v === undefined || v === ''
					? undefined
					: getHigherUnitAndQuantity(product?.unit, v)?.[0];
			const preBatchProductionQty =
				product?.calculatedQty != null
					? conv(product?.calculatedQty) +
					(product?.calculatedQtyNonAdjusted < 0
						? // eslint-disable-next-line prefer-template
						'(' + conv(product?.calculatedQtyNonAdjusted) + ')'
						: '')
					: '-';
			// NOTE: order MUST match SPECIAL_COLUMns (with 'Variant Name'/'Sku Type'
			// inserted after Product Name). 'Recommended Production Qty' sits between
			// 'Order Quantity...' and 'Forecast for Next 7 Days'.
			totalValues?.push([
				product?.productName ?? '-',                       // Product Name
				product?.variantName ?? '-',                       // Variant Name
				product?.productType ?? '-',                       // Sku Type
				higherUnit,                                        // Unit
				productInfo?.categoryName ?? '-',                  // Category
				productInfo?.subCategoryName ?? '-',               // Sub Category
				skuCode,                                           // SKU Code
				'-',                                               // Measure Quantity
				product?.fromProcess ?? '-',                       // From Process
				product?.toProcess ?? '-',                         // To Process
				yieldProcessLabel,                                 // Select Yield Process
				str || '-',                                        // Scheduled
				conv(product?.plannedForConsumption) ?? '-',       // Planned For Consumption
				conv(product?.plannedToBeReceived) ?? '-',         // Planned To be Received
				conv(product?.stock) ?? '-',                       // Stock At
				conv(product?.stock) ?? '-',                       // Left Over (Input)
				conv(product?.extraScheduled) ?? '-',              // Plan Planned Extra Production
				conv(product?.currentDayStockIn) ?? '-',           // Plan Produced till
				conv(product?.currentDayCount) ?? '-',             // Plan Planned Production
				conv(product?.prePlanStock) ?? '-',                // Projected Stock
				conv(product?.threshold) ?? '-',                   // Minimum Stock
				conv(product?.orderedQty) ?? '-',                  // Order Quantity PO Delivery Date
				conv(getRecommendedQty(product)) ?? '-',           // Recommended Production Qty
				conv(product?.forecasted) ?? '-',                  // Forecast for Next 7 Days
				delta ?? '-',                                      // Production Factor
				reasonLabel,                                       // Reason
				conv(product?.expectedLeftOver) ?? '-',            // Expected Left Over
				conv(product?.totalRequiredQty) ?? '-',            // Required Stock
				conv(product?.stock) ?? '-',                       // Current Stock
				statusText,                                        // Status
				conv(product?.calculatedQtyNonAdjusted) ?? '-',    // Pre Batch Without Left Over
				(conv(product?.leftOver) ?? '') + '/' + (conv(product?.inputLeftOver) ?? ''), // Left Over (Used/Input)
				conv(product?.plannedLeftOver) ?? '-',             // Left Over (Already Planned)
				conv(product?.leftOver) ?? '-',                    // Left Over (From Executed plans)
				preBatchProductionQty,                             // Pre Batch Production Quantity
				conv(product?.suggestedQty) ?? '-',                // Possible Production Qty
				product?.wastage ?? '-',                           // Wastage %
				conv(product?.batchSize) ?? '-',                   // Batch Size
				conv(product?.finalProduction) ?? '-',             // Final Production
				product?.batchCount ?? '-',                        // No of batches
				product?.shiftId ?? '-',                           // Shift ID
				product?.shiftName ?? '-',                         // Shift Name
				product?.parentProduct ?? '-',                     // Parent Product
				conv(product?.kitBatchSize) ?? '-',                // Kit Batch Size
				product?.kitCount ?? '-',                          // Kit Count
				product?.labellingDate ?? '-',                     // Labelling Date
				product?.scheduledDate ?? '-',                     // Scheduled Date
			]);
		});
		// Only export columns that are actually visible in the table for the current view.
		// Visibility is per-type and also gated by customer flags (e.g. isLeftOverCheck),
		// so a column like 'Left Over (From Executed plans)' drops out when the customer
		// doesn't have left-over check.
		const columnCtx = {
			lppId: !!data?.lppId,
			customerId: String(appConfig?.customerId),
			hasRecipeStatus: !!(
				listData?.recipeApprovalStatus &&
				typeof listData.recipeApprovalStatus === 'object' &&
				Object.keys(listData.recipeApprovalStatus).length > 0
			),
			hasReasons: !!(reasonList && reasonList.length > 0),
			isLeftOverCheck,
			isA2bCustomer,
			labels: {
				plannedDate,
				stockCheckedAt,
				stockCheckAtDate,
				nextStockCheckAtDate,
				scheduledFor,
			},
		};
		// Export only the columns visible for the currently selected type, so the export
		// matches what the user sees on screen (e.g. Measure Quantity / From Process /
		// To Process / Planned For Consumption / Reason / Wastage % are hidden for PRODUCT).
		const visibleTitles = new Set(
			getProductionPlanColumns(SPECIAL_COLUMNS, {
				...columnCtx,
				type: selectedType?.value || 'PRODUCT',
			}).map((col) => col?.title)
		);
		// 'Variant Name' and 'Sku Type' are injected into the export header (not part of
		// SPECIAL_COLUMNS), so always keep them.
		const alwaysKeep = new Set(['Variant Name', 'Sku Type']);
		const keepIdx = headers.reduce((acc, title, idx) => {
			if (alwaysKeep.has(title) || visibleTitles.has(title)) acc.push(idx);
			return acc;
		}, []);
		// Same tab-based display names as the table (Finished Good / Semi
		// Finished Good / Raw Materials, Parent Product (FG/SFG)).
		const exportHeaders = keepIdx.map((idx) => displayColumnTitle(headers[idx]));
		const exportValues = totalValues.map((row) => keepIdx.map((idx) => row[idx]));
		handleExcelDownload(
			exportHeaders,
			exportValues,
			`Production Plan for ${moment(selectedDate).format('DD-MMM')}`,
			true
		);
	};
	const storeName = stores?.find(s => s.id === data?.storeId)?.name || '';

	const handleExportPdf = async () => {
		const rows = DATA || [];
		if (!rows.length) {
			notificationServices.generateNotification({
				type: 'warning',
				message: 'No items to export.',
			});
			return;
		}

		const productLabel = (product) => {
			const parent =
				product?.parentProduct && product?.parentProduct !== '-'
					? product?.parentProduct
					: product?.productName;
			return product?.variantName
				? `${parent ?? ''} (${product.variantName})`
				: (parent || '-');
		};
		const skuOf = (product) => {
			const productInfo = products?.find((val) => val?.id === product?.productId);
			const sku =
				product?.clientVariantId ??
				productInfo?.variants?.find((v) => v?.id === product?.variantId)?.clientVariantId;
			return sku != null && sku !== '' ? String(sku) : '-';
		};
		const plannedQtyOf = (product) => {
			// "Planned" = Final Production, shown in the higher (display) unit.
			const [value] = getHigherUnitAndQuantity(product?.unit, product?.finalProduction);
			const unit = displayUnitOf(product);
			if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
				return '-';
			}
			return `${Number(value)} ${unit || ''}`.trim();
		};
		// Product / Intermediate print their own name (with variant), not the parent.
		const productNameLabel = (product) =>
			product?.variantName
				? `${product?.productName ?? ''} (${product.variantName})`
				: (product?.productName || '-');
		// "Process" = the selected Yield Process (To Process) — heading (section).
		const yieldProcessOf = (product) => {
			const yp = processList?.find((ele) => Number(ele?.id) === Number(product?.toProcessId));
			if (!yp) return '-';
			const heading = yp?.data?.heading ?? '';
			const section = yp?.data?.sectionName ?? '';
			return section ? `${heading} (${section})` : (heading || '-');
		};

		// eslint-disable-next-line new-cap
		const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const pageHeight = doc.internal.pageSize.getHeight();
		const marginX = 10;
		const headerTop = 30; // table starts below the branded page header
		const bottomMargin = 16; // leave room for the branded footer
		const cellPadding = 2;
		const lineHeight = 4.2;

		// Columns differ per tab:
		//  • INGREDIENT — Parent Product + Ingredient Name, "From Process", "Planned Qty".
		//  • PRODUCT / INTERMEDIATE — own Product Name, "Process" (Select Yield Process)
		//    and "Planned" (Final Production). PRODUCT is sorted by process then name.
		const isIngredientTab = selectedType?.value === 'INGREDIENT';
		const isProductTab = selectedType?.value === 'PRODUCT';

		let cols;
		let buildRow;
		if (isIngredientTab) {
			cols = [
				{ key: 'product', label: displayColumnTitle('Parent Product'), width: 46 },
				{ key: 'sku', label: 'SKU Code', width: 22 },
				{ key: 'process', label: 'From Process', width: 28 },
				{ key: 'ingredient', label: displayColumnTitle('Product Name'), width: 46 },
				{ key: 'qty', label: 'Planned Qty', width: 26 },
				{ key: 'fulfilled', label: 'Fulfilled', width: 22 },
			];
			buildRow = (product) => ({
				product: productLabel(product),
				sku: skuOf(product),
				process: product?.fromProcess || '-',
				ingredient: product?.productName ?? '-',
				qty: plannedQtyOf(product),
				fulfilled: '',
			});
		} else {
			cols = [
				{ key: 'product', label: displayColumnTitle('Product Name'), width: 78 },
				{ key: 'sku', label: 'SKU Code', width: 30 },
				{ key: 'process', label: 'Process', width: 40 },
				{ key: 'qty', label: 'Planned', width: 20 },
				{ key: 'fulfilled', label: 'Fulfilled', width: 22 },
			];
			buildRow = (product) => ({
				product: productNameLabel(product),
				sku: skuOf(product),
				process: yieldProcessOf(product),
				qty: plannedQtyOf(product),
				fulfilled: '',
			});
		}

		// Sort rows by process then by the primary name:
		//  • PRODUCT — Select Yield Process, then Product Name.
		//  • INGREDIENT — From Process (section), then Parent Product.
		let sourceRows = rows;
		if (isProductTab) {
			sourceRows = [...rows].sort((a, b) => {
				const pa = yieldProcessOf(a).toLowerCase();
				const pb = yieldProcessOf(b).toLowerCase();
				if (pa !== pb) return pa.localeCompare(pb);
				return String(a?.productName || '').toLowerCase()
					.localeCompare(String(b?.productName || '').toLowerCase());
			});
		} else if (isIngredientTab) {
			sourceRows = [...rows].sort((a, b) => {
				const pa = String(a?.fromProcess || '').toLowerCase();
				const pb = String(b?.fromProcess || '').toLowerCase();
				if (pa !== pb) return pa.localeCompare(pb);
				return String(a?.parentProduct || '').toLowerCase()
					.localeCompare(String(b?.parentProduct || '').toLowerCase());
			});
		}
		const tableRows = sourceRows.map(buildRow);

		const title = `Production Plan for ${moment(selectedDate).format('DD-MMM')}${storeName ? ` (${storeName})` : ''}`;
		const subtitle = `${selectedType?.value || ''} · ${tableRows.length} item(s)`;

		// --- Branding (matches the app / invoice): company logo + #4a70fb theme + footer ---
		const BRAND = { r: 74, g: 112, b: 251 };        // #4a70fb (app primary)
		const HEADER_TINT = { r: 237, g: 242, b: 255 }; // light brand tint for the header row
		const ZEBRA = { r: 247, g: 249, b: 255 };        // very light brand tint for alt rows
		const companyLogo = appConfig?.logob64 || appConfig?.logo || null;
		const companyName = appConfig?.companyName || '';

		// Load an image (data-URI or asset URL) into a PNG data-URL + natural size.
		// Resolves null on any failure so a missing/broken logo never blocks the export.
		const loadImageAsPng = (src) => new Promise((resolve) => {
			if (!src) { resolve(null); return; }
			try {
				const img = new Image();
				img.crossOrigin = 'anonymous';
				img.onload = () => {
					try {
						const canvas = document.createElement('canvas');
						canvas.width = img.naturalWidth || img.width;
						canvas.height = img.naturalHeight || img.height;
						canvas.getContext('2d').drawImage(img, 0, 0);
						resolve({
							dataUrl: canvas.toDataURL('image/png'),
							w: canvas.width,
							h: canvas.height,
						});
					} catch (e) {
						resolve(null);
					}
				};
				img.onerror = () => resolve(null);
				img.src = src;
			} catch (e) {
				resolve(null);
			}
		});
		// Draw a preloaded image contained (aspect-fit, centered) within a box.
		const placeImage = (info, x, y, boxW, boxH) => {
			if (!info?.dataUrl) return;
			const ar = info.w / info.h;
			let w = boxW;
			let h = boxH;
			if (ar > boxW / boxH) h = boxW / ar;
			else w = boxH * ar;
			try {
				doc.addImage(info.dataUrl, 'PNG', x + (boxW - w) / 2, y + (boxH - h) / 2, w, h);
			} catch (e) {
				/* ignore image failures */
			}
		};

		const companyLogoImg = await loadImageAsPng(companyLogo);
		const footerLogoImg = await loadImageAsPng(uyLogo);

		const drawPageHeader = () => {
			if (companyLogoImg) placeImage(companyLogoImg, marginX, 7, 38, 16);
			if (companyName) {
				doc.setFont(undefined, 'bold');
				doc.setFontSize(11);
				doc.setTextColor(45);
				doc.text(companyName, marginX + (companyLogoImg ? 42 : 0), 13);
			}
			// Title + subtitle, right-aligned in the brand colour.
			doc.setFont(undefined, 'bold');
			doc.setFontSize(13);
			doc.setTextColor(BRAND.r, BRAND.g, BRAND.b);
			doc.text(title, pageWidth - marginX, 12, { align: 'right' });
			doc.setFont(undefined, 'normal');
			doc.setFontSize(9);
			doc.setTextColor(120);
			doc.text(subtitle, pageWidth - marginX, 17.5, { align: 'right' });
			// Brand rule under the header.
			doc.setDrawColor(BRAND.r, BRAND.g, BRAND.b);
			doc.setLineWidth(0.6);
			doc.line(marginX, 23, pageWidth - marginX, 23);
			doc.setLineWidth(0.2);
			doc.setTextColor(40);
		};

		const drawHeaderRow = (y) => {
			doc.setFont(undefined, 'bold');
			doc.setFontSize(9);
			// Wrap header labels within their column so a long label never spills
			// into the neighbouring column (e.g. "Planned Qty" / "Fulfilled").
			const wrapped = cols.map((c) =>
				doc.splitTextToSize(c.label, c.width - cellPadding * 2));
			const maxLines = Math.max(1, ...wrapped.map((w) => w.length));
			const h = Math.max(8, maxLines * lineHeight + 3);
			doc.setFillColor(HEADER_TINT.r, HEADER_TINT.g, HEADER_TINT.b);
			doc.setDrawColor(BRAND.r, BRAND.g, BRAND.b);
			doc.rect(marginX, y, pageWidth - marginX * 2, h, 'FD');
			doc.setTextColor(BRAND.r, BRAND.g, BRAND.b);
			let x = marginX;
			cols.forEach((c, ci) => {
				doc.text(wrapped[ci], x + cellPadding, y + lineHeight + 0.5);
				x += c.width;
			});
			doc.setFont(undefined, 'normal');
			doc.setTextColor(40);
			return y + h;
		};

		drawPageHeader();
		let y = drawHeaderRow(headerTop);

		tableRows.forEach((r, idx) => {
			doc.setFontSize(8.5);
			const wrapped = cols.map((c) =>
				doc.splitTextToSize(String(r[c.key] ?? ''), c.width - cellPadding * 2));
			const maxLines = Math.max(1, ...wrapped.map((w) => w.length));
			const rowH = maxLines * lineHeight + 3;

			if (y + rowH > pageHeight - bottomMargin) {
				doc.addPage();
				drawPageHeader();
				y = drawHeaderRow(headerTop);
			}

			if (idx % 2 === 1) {
				doc.setFillColor(ZEBRA.r, ZEBRA.g, ZEBRA.b);
				doc.rect(marginX, y, pageWidth - marginX * 2, rowH, 'F');
			}

			let x = marginX;
			doc.setDrawColor(224);
			doc.setTextColor(40);
			doc.setFontSize(8.5);
			cols.forEach((c, ci) => {
				doc.rect(x, y, c.width, rowH);
				doc.text(wrapped[ci], x + cellPadding, y + lineHeight + 0.5);
				x += c.width;
			});
			y += rowH;
		});

		// Footer on every page: rule + "Powered by …" + UY logo + page number.
		const pageCount = doc.internal.getNumberOfPages();
		for (let p = 1; p <= pageCount; p += 1) {
			doc.setPage(p);
			const fy = pageHeight - 8;
			doc.setDrawColor(225);
			doc.setLineWidth(0.3);
			doc.line(marginX, fy - 5, pageWidth - marginX, fy - 5);
			doc.setFont(undefined, 'normal');
			doc.setFontSize(7.5);
			doc.setTextColor(140);
			doc.text('Powered by Food Production and Supply Chain AI Tech from', marginX, fy);
			if (footerLogoImg) placeImage(footerLogoImg, marginX + 76, fy - 4.5, 24, 7);
			doc.setTextColor(150);
			doc.text(`Page ${p} of ${pageCount}`, pageWidth - marginX, fy, { align: 'right' });
		}

		const fileName = `Production_Plan_${moment(selectedDate).format('DD-MMM')}_${selectedType?.value || 'ALL'}.pdf`;
		doc.save(fileName);
	};

	const tableColumns = buildVariantTableColumns(
		getProductionPlanColumns(SPECIAL_COLUMNS, {
			type: selectedType?.value,
			lppId: !!data?.lppId,
			customerId: String(appConfig?.customerId),
			hasRecipeStatus: !!(
				listData?.recipeApprovalStatus &&
				typeof listData.recipeApprovalStatus === 'object' &&
				Object.keys(listData.recipeApprovalStatus).length > 0
			),
			hasReasons: !!(reasonList && reasonList.length > 0),
			isLeftOverCheck,
			isA2bCustomer,
			labels: {
				plannedDate,
				stockCheckedAt,
				stockCheckAtDate,
				nextStockCheckAtDate,
				scheduledFor,
			},
		})
	)?.map((col) => {
		let out = col;
		if (data?.lppId && col?.key === 'Pre Batch Production Quantity') {
			out = { ...out, title: 'Planned Qty' };
		}
		// Tab-based display names — the column KEY stays 'Product Name' /
		// 'Parent Product' (COLMAP, renderers and groups depend on it); only
		// the visible header title changes (shared with excel/PDF exports).
		const displayed = displayColumnTitle(col?.key);
		if (displayed !== col?.key) {
			out = { ...out, title: displayed };
		}
		return out;
	});
	const tableColMapping =
		selectedType?.value === 'PACKAGING' ? {} : COLMAP;

	const tableCustomRowData = {};
	tableColumns.forEach(({ key }) => {
		const renderer = SPECIAL_ITEMS[key];
		const hasColMap = Object.prototype.hasOwnProperty.call(
			tableColMapping,
			key
		);
		if (renderer) {
			tableCustomRowData[key] = (product) => toDisplay(renderer(product));
		} else if (!hasColMap) {
			tableCustomRowData[key] = () => '-';
		}
	});

	const showPasteBtn =
		!data?.nonEditable && !data?.finalProductionNonEditable
		&& selectedType?.value === 'PRODUCT';

	const emptyFinalProductionNames = getEmptyFinalProductionNames();
	const lppBatchInvalidNames = getLppBatchInvalidProductNames();
	const editedProductNames = getEditedProductNames();
	const pendingRecipeProductNames = getPendingRecipeProductNames();

	const hasWarning =
		checkLowStock() ||
		(Object.keys(isEdit)?.length > 0 || Object.keys(isEditFinalProduction)?.length > 0) ||
		emptyFinalProductionNames.length > 0 ||
		lppBatchInvalidNames.length > 0 ||
		pendingRecipeProductNames.length > 0;

	const hasEdits = Object.keys(isEdit)?.length > 0 || Object.keys(isEditFinalProduction)?.length > 0;
	const hasMeaningfulChange = [
		...(listData?.PRODUCT ?? []),
		...(listData?.INTERMEDIATE ?? []),
		...(listData?.UNPACKED_PRODUCT ?? []),
		...(listData?.PACKAGING ?? []),
	].some((ele) => {
		const initial = Number(ele?.initialProductionQty);
		const current = Number(ele?.finalProduction);
		const fpChanged = Number.isFinite(initial) && Number.isFinite(current) && current !== initial;
		const factorChanged = ele?.delta != null && Number(ele?.delta) !== 0;
		return fpChanged || factorChanged;
	});
	const hasBlockingError = emptyFinalProductionNames.length > 0 || lppBatchInvalidNames.length > 0;

	return (
		<BaseModal
			customHeading={() => (
				<div className='flex w-full items-center justify-between gap-3 pl-4 pr-14 mb-2'>
					<div className='font-semibold text-lg'>
						{data?.editMode
							? `Edit Production Plan for ${moment(selectedDate).format('DD-MMM')} ${storeName ? `(${storeName})` : ''}`
							: `Production Plan for ${moment(selectedDate).format('DD-MMM')} ${storeName ? `(${storeName})` : ''}`}
					</div>
					<div className='flex items-center gap-2 shrink-0'>
						<div className='flex items-center gap-2 text-xs text-gray-600 border border-gray-200 rounded-md px-3 py-1.5 bg-gray-50'>
							<span className='relative px-2'>
								Row
								<span className='absolute left-0 right-0 top-1/2 h-px bg-black'></span>
							</span>
							<span className='text-gray-500'>= Not Scheduled</span>
						</div>
						{showPasteBtn && (
							<Button
								variant='outline'
								className='text-xs h-9 flex items-center gap-1.5'
								onClick={handlePasteProductionPlan}
							>
								Paste from Excel
								<Tooltip title='Format: Product Name | SKU Code | UOM | Qty (tab-separated, copied from Excel)'>
									<span
										className='inline-flex cursor-pointer bg-yellow-100'
										onClick={(e) => {
											e.stopPropagation();
											setShowPasteFormat(true);
										}}
									>
										<Info size={14} className='text-gray-500 hover:text-gray-700' />
									</span>
								</Tooltip>
							</Button>
						)}
						<div
							onClick={handleExport}
							className='flex items-center gap-1.5 h-9 cursor-pointer text-xs font-semibold text-green-700 border border-green-300 rounded-md px-3 bg-green-50 hover:bg-green-100 transition-colors'
							title='Export to Excel'
						>
							<img src={excel} alt='excel' className='w-4 h-4 bg-green-700' />
							EXPORT
						</div>
						<div
							onClick={handleExportPdf}
							className='flex items-center gap-1.5 h-9 cursor-pointer text-xs font-semibold text-red-700 border border-red-300 rounded-md px-3 bg-red-50 hover:bg-red-100 transition-colors'
							title={`Export to PDF (Parent Product, SKU, From Process,${selectedType?.value === 'INGREDIENT' ? ' Ingredient Name,' : ''} Planned Qty, Fulfilled)`}
						>
							<FileText size={16} />
							EXPORT PDF
						</div>
					</div>
				</div>
			)}
			open={show}
			handleClose={handleClose}
			customStyles={{
				width: '95%',
				height: '95vh',
				...(data?.editMode && { background: 'rgb(255 254 248)' }),
			}}
			renderBtns={renderBtns}
			disableBackdropClick
			disableEscapeKeyDown
		>
			<AlertModal />
			<BaseModal
				open={showPasteFormat}
				handleClose={() => setShowPasteFormat(false)}
				heading='Paste from Excel — Format'
				customStyles={{ width: '540px', height: 'auto' }}
				hideFooter
			>
				<div className='text-sm text-gray-700 space-y-3 p-1'>
					<p>Copy rows from Excel (tab-separated) in this column order, then click <b>Paste from Excel</b>:</p>
					<table className='w-full border border-gray-200 text-xs'>
						<thead className='bg-gray-50'>
							<tr>
								<th className='border border-gray-200 px-2 py-1 text-left'>Product Name</th>
								<th className='border border-gray-200 px-2 py-1 text-left'>SKU Code</th>
								<th className='border border-gray-200 px-2 py-1 text-left'>UOM</th>
								<th className='border border-gray-200 px-2 py-1 text-left'>Qty</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className='border border-gray-200 px-2 py-1 text-left'>Classic Sourdough</td>
								<td className='border border-gray-200 px-2 py-1 text-left'>SR-DGH-001</td>
								<td className='border border-gray-200 px-2 py-1 text-left'>kg</td>
								<td className='border border-gray-200 px-2 py-1 text-left'>180</td>
							</tr>
						</tbody>
					</table>
					<ul className='list-disc pl-5 text-xs text-gray-600 space-y-1'>
						<li>Rows are matched by <b>SKU Code</b> (column 2).</li>
						<li>The <b>Qty</b> (column 4) is applied to Final Production.</li>
						<li>A header row is auto-skipped if present.</li>
					</ul>
				</div>
			</BaseModal>
			<div className={`${styles.root}`}>
				<div className='w-full flex items-center flex-nowrap gap-3'>
					<Input
						className='w-[140px] shrink-0'
						value={searchQuery}
						onChange={(e) => { setSearchQuery(e.target.value); }}
						placeholder='Search SKU'
					/>
					<div className='flex items-center rounded-md border border-gray-300 overflow-hidden shrink-0'>
						{skuTypes?.map((ele, idx) => {
							const isActiveTab = selectedType?.value === ele?.value;
							return (
								<button
									key={ele?.value}
									type='button'
									onClick={() => setSelectedType(ele)}
									className={`flex items-center gap-2 px-5 py-2.5 text-sm font-semibold whitespace-nowrap transition-colors ${idx > 0 ? 'border-l border-gray-300' : ''}`}
									style={{
										background: isActiveTab ? ele?.color : `${ele?.color}4D`,
										color: isActiveTab ? ele?.darkColor : '#9ca3af',
										fontWeight: isActiveTab ? 700 : 500,
										...(isActiveTab ? { boxShadow: `inset 0 -2px 0 0 ${ele?.darkColor}` } : {}),
									}}
								>
									{ele?.value}
								</button>
							);
						})}
					</div>
					{/* Planning for Date */}
					<div className='flex items-center gap-2 shrink-0'>
						<label className='text-red-600 font-medium whitespace-nowrap text-xs'>Planning for Date</label>
						<DatePicker
							placeholder='dd/MM/yyyy'
							format='dd/MM/yyyy'
							className='w-[140px]'
							value={selectedDate}
							onChange={(date) => setSelectedDate(date)}
							menuStyle={{ zIndex: 1000 }}
							placement='bottomStart'
							cleanable={false}
							disabled={data?.nonEditable}
							disabledDate={(date) => date < new Date().setHours(0, 0, 0, 0)}
						/>
					</div>
					{/* Select Shift */}
					<div className='flex items-center gap-2 shrink-0'>
						<label className='font-medium whitespace-nowrap text-xs text-red-400'>Select Shift *</label>
						<SelectPicker
							data={filteredShiftList?.map((ele) => ({ label: ele?.shiftName, value: ele?.id }))}
							placeholder='Select'
							className='w-[150px]'
							menuStyle={{ zIndex: 10000 }}
							value={shiftId}
							onChange={(value) => setShiftId(value)}
							placement='bottomStart'
							cleanable={true}
							searchable={true}
							disabled={data?.nonEditable}
						/>
					</div>
					{/* Plan Name */}
					{!data?.hideButtons && (
						<div className='flex items-center gap-2 flex-1 min-w-[120px]'>
							<label className='text-red-600 font-medium whitespace-nowrap text-xs'>Plan Name</label>
							<Input
								value={planDescription}
								onChange={handleChange}
								placeholder='Description'
								className='flex-1'
							/>
						</div>
					)}
				</div>
				<div
					style={{
						background: selectedType?.color,
						marginTop: '12px',
						border: '1px solid #e5e7eb',
						borderTop: `3px solid ${selectedType?.color}`,
						borderRadius: '8px',
						...(data?.hideButtons
							? {}
							: { height: hasWarning ? 'calc(100vh - 18rem)' : 'calc(100vh - 14rem)' }),
					}}
					className={classes(
						styles.list,
						data?.hideButtons ? styles.fullHeight : ''
					)}
				>
					<VariantTable
						data={DATA}
						columns={tableColumns}
						colMapping={tableColMapping}
						customRowData={tableCustomRowData}
						customInfoLine='No items to display'
						headerCellClassName='bg-white'
						headerRowClassName='bg-white'
					/>
				</div>
				<div className='flex flex-col gap-1.5 items-center w-full'>
					{checkLowStock() && (
						<p className='text-xs font-medium text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-1.5 w-full text-center'>
							Certain items in this plan cannot be fullfilled
							completely due to low stock. Please check the plan and
							adjust the quantities accordingly to generate the
							production plan.
						</p>
					)}
					{emptyFinalProductionNames.length > 0 && (
						<p className='text-xs font-medium text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-1.5 w-full text-center'>
							Final production is empty for: {emptyFinalProductionNames.join(', ')}.
						</p>
					)}
					{pendingRecipeProductNames.length > 0 && (
						<p className='text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md px-3 py-1.5 w-full text-center'>
							The newly added recipe is pending approval and will not be used for: {pendingRecipeProductNames.length > 2 ? pendingRecipeProductNames.slice(0, 2).join(', ') + ' ...' : pendingRecipeProductNames.join(', ')}. The previously approved recipe will be used instead.
						</p>
					)}
					{lppBatchInvalidNames.length > 0 && (
						<p className='text-xs font-medium text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-1.5 w-full text-center'>
							The production quantity must be a multiple of the batch size for: {lppBatchInvalidNames.join(', ')}.
						</p>
					)}
					{hasEdits && hasMeaningfulChange && !hasBlockingError && (
						<p className='text-xs font-medium text-amber-600 bg-amber-50 border border-amber-200 rounded-md px-3 py-1.5 w-full text-center'>
							The production manual factor has changed{editedProductNames.length > 0 ? ` for: ${editedProductNames.join(', ')}` : ''}. Please save the changes and recalculate the plan to generate.
						</p>
					)}
				</div>
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.productionPlanModal;
	const stores = state?.form?.STORES?.data?.LIST;
	return {
		show,
		data,
		stores,
	};
};

const mapDispatchToProps = {
	toggleProductionPlanModal: modalActions.toggleProductionPlanModal,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductionPlanModal);
